import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import DataView from "./DataView";
import PopupupScreen from "./PopupupScreen";
import { LanguageContext } from "./LanguageContext";
import "./DataList.css";
import "./new_DataList.css";

// import "./Vishal.css";
// import "./Trial.css";
import MuiAlert from "@mui/material/Alert";
import DatePicker from "react-datepicker";
import { IconButton } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { IoCloseOutline } from "react-icons/io5";
import "react-datepicker/dist/react-datepicker.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { FcCalendar } from "react-icons/fc";
import { Edit as EditIcon } from "@mui/icons-material";
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Navbar from "./Navbar";
import { IoPrintOutline } from "react-icons/io5";
import { FiEdit, FiPlus, FiSearch } from "react-icons/fi";
import { css } from "@emotion/react";
import Pagination from "./Pagination";
import InsertData from "./InsertData";
import { BeatLoader } from "react-spinners";
import { MdDeleteOutline } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import CustodyLog from "./CustodyLog";
import { CgArrowsScrollV } from "react-icons/cg";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import Multiselect from "multiselect-react-dropdown";
import { PiPencilSimpleLineLight } from "react-icons/pi";
import { MdAttachFile } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import { BsInfoCircle } from "react-icons/bs";
import { PiArrowCircleRightLight } from "react-icons/pi";
import Snackbar from "@mui/material/Snackbar";
import { MdExpandMore, MdSort } from "react-icons/md";
import TextField from "@mui/material/TextField";
import mrTranslations from "./translations/mr.json";
import { UI_TRANSLATIONS } from "./translations/ui";
import HierarchyFilterBar from "./components/report/HierarchyFilterBar";
import SearchableSelect from "./components/common/SearchableSelect";
import EntryTypeFields from "./components/common/EntryTypeFields";
import CasePropertyTable from "./components/register/CasePropertyTable";
import { getDistricts } from "./services/districtService";
import { getSubDivisions } from "./services/subDivisionService";
import { getStations } from "./services/stationService";
import {
  ALL_DATES_FILTER_OPTION,
  fetchCrimeBranchRecords,
  fetchFilteredCrimeRecords,
  exportCrimeData,
  normalizeDateFilterOption,
} from "./services/reportService";
import { getMasterDomainItems } from "./services/masterDataService";
import {
  buildScopeFromHierarchySelection,
  ensureFixedOption,
  getHierarchyScopeAccess,
  resolveSelectedOptionLabel,
} from "./utils/hierarchyScope";
import {
  buildActOptions,
  buildCasePropertyTypeOptions,
  buildStatusOptions,
  buildUnitOptions,
  buildVehicleReasonOptions,
  isOtherActOption,
  isOtherCasePropertyType,
  isVehicleCasePropertyType,
  matchActOptionsByNames,
  matchOptionValue,
} from "./utils/casePropertyMasterOptions";

import { parse, format } from "date-fns";
import API_URL from "./Config";
import { fa0 } from "@fortawesome/free-solid-svg-icons";
import { useCapabilities } from "./contexts/CapabilitiesContext";
import {
  buildEntryTypeValidationErrors,
  DEFAULT_ENTRY_TYPE_OPTIONS,
  getEntryTypeLabel,
  normalizeEntryTypeOptions,
  normalizeEntryTypeRecord,
  sanitizeRecordForEntryType,
} from "./utils/entryTypeHelpers";
const loaderStyle = css`
  display: inline-block;
  margin: 20px auto;
`;

const safeIncludes = (value, search) =>
  String(value ?? "")
    .toLowerCase()
    .includes(String(search ?? "").toLowerCase());
const getStoredUserState = () => {
  const storedState = String(localStorage.getItem("userState") ?? "").trim();
  const normalizedState = storedState.toLowerCase();

  return normalizedState === "null" || normalizedState === "undefined"
    ? ""
    : storedState;
};

const ensureArray = (value) => (Array.isArray(value) ? value : []);
const getValidDate = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};
const matchesDateFilter = (
  row,
  selectedOption,
  selectedStartDate,
  selectedEndDate,
) => {
  const normalizedFilterOption = normalizeDateFilterOption(selectedOption);

  if (
    !normalizedFilterOption ||
    normalizedFilterOption === ALL_DATES_FILTER_OPTION
  ) {
    return true;
  }

  const recordDate = getValidDate(row?.date_of_seizure);
  if (!recordDate) {
    return false;
  }

  const end = new Date();
  end.setHours(23, 59, 59, 999);
  const start = new Date(end);

  switch (normalizedFilterOption) {
    case "today":
      start.setHours(0, 0, 0, 0);
      return recordDate >= start && recordDate <= end;
    case "this_month":
      start.setDate(1);
      start.setHours(0, 0, 0, 0);
      return recordDate >= start && recordDate <= end;
    case "next_month": {
      const nextMonthStart = new Date(end.getFullYear(), end.getMonth() + 1, 1);
      const nextMonthEnd = new Date(
        end.getFullYear(),
        end.getMonth() + 2,
        0,
        23,
        59,
        59,
        999,
      );

      return recordDate >= nextMonthStart && recordDate <= nextMonthEnd;
    }
    case "last_week":
      start.setDate(start.getDate() - 7);
      break;
    case "last_month":
      start.setMonth(start.getMonth() - 1);
      break;
    case "last_three_months":
      start.setMonth(start.getMonth() - 3);
      break;
    case "last_six_months":
      start.setMonth(start.getMonth() - 6);
      break;
    case "custom": {
      if (!selectedStartDate || !selectedEndDate) {
        return true;
      }
      const customStart = new Date(selectedStartDate);
      const customEnd = new Date(selectedEndDate);
      customStart.setHours(0, 0, 0, 0);
      customEnd.setHours(23, 59, 59, 999);
      return recordDate >= customStart && recordDate <= customEnd;
    }
    default:
      return true;
  }

  start.setHours(0, 0, 0, 0);
  return recordDate >= start && recordDate <= end;
};
const sortRecords = (records, sortOrder) =>
  [...records].sort((a, b) => {
    const newestFirst = () =>
      (getValidDate(b?.date_of_seizure)?.getTime() || 0) -
      (getValidDate(a?.date_of_seizure)?.getTime() || 0);
    const oldestFirst = () => -newestFirst();
    const compareText = (first, second) =>
      String(first ?? "").localeCompare(String(second ?? ""), undefined, {
        numeric: true,
        sensitivity: "base",
      });
    const compareNumber = (first, second) =>
      (Number(first) || 0) - (Number(second) || 0);

    switch (sortOrder) {
      case "નવીનતમ":
      case "તારીખ":
        return newestFirst();
      case "જૂના":
      case "તારીખ_જપ્ત_કર્યા_ની":
        return oldestFirst();
      case "AtoZ":
        return compareText(a?.description, b?.description);
      case "ZtoA":
        return compareText(b?.description, a?.description);
      case "સરનો":
        return compareText(a?.serial_number, b?.serial_number);
      case "ગુના_નો":
        return compareText(a?.guna_number, b?.guna_number);
      case "મુદ્દામાલ_પાવતી_નો":
        return compareText(a?.exhibit_number, b?.exhibit_number);
      case "જથ્થો":
        return compareNumber(a?.quantity, b?.quantity);
      case "કિંમત":
        return compareNumber(a?.price, b?.price);
      default:
        return 0;
    }
  });
const normalizeTextValue = (value, fallback = "NA") => {
  const nextValue = String(value ?? "").trim();
  return nextValue || fallback;
};
const RECORDS_FILTER_OPTION_STORAGE_KEY = "recordsFilterOption";
const RECORDS_HIERARCHY_SCOPE_STORAGE_KEY = "recordsHierarchyScope";
const INITIAL_EXPORT_OPTIONS = {
  entryType: "",
  format: "xlsx",
  lang: "en",
  endDate: "",
  startDate: "",
  status: "",
};
const getStoredRecordsScope = () => {
  try {
    const storedScope = localStorage.getItem(
      RECORDS_HIERARCHY_SCOPE_STORAGE_KEY,
    );
    return storedScope ? JSON.parse(storedScope) : {};
  } catch (error) {
    console.error("Failed to parse stored records scope:", error);
    return {};
  }
};
const extractFilenameFromHeaders = (
  headers = {},
  fallback = "case-property-data.xlsx",
) => {
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);

  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
  return filenameMatch?.[1] || fallback;
};

function DataList() {
  const {
    can,
    canAny,
    capabilities,
    loading: capabilitiesLoading,
    user,
  } = useCapabilities();
  const isCapabilitiesReady = !capabilitiesLoading && capabilities !== null;
  const canReadAdminReports =
    isCapabilitiesReady && can("reports", "read_admin");
  const canReadCrimeData = canAny("crime_data", ["read", "manage"]);
  const canUpdateCrimeData = canAny("crime_data", ["update", "manage"]);
  const initialStoredScope = getStoredRecordsScope();
  const {
    canSelectDistrict,
    canSelectStation,
    canSelectSubDivision,
    canUseAdminHierarchy,
    fixedDistrictId,
    fixedStationId,
    fixedSubDivisionId,
    normalizeScopeId,
    showDistrictField,
    showStationField,
    showSubDivisionField,
  } = getHierarchyScopeAccess({
    canReadAdminReports,
    capabilitiesReady: isCapabilitiesReady,
    user,
  });
  const [data, setData] = useState([]);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showDeleteSuccessAlert, setShowDeleteSuccessAlert] = useState(false);
  const [showQRGeneratedSuccessAlert, setShowQRGeneratedSuccessAlert] =
    useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [sectionCfslName, setSectionCfslName] = useState("");
  const [selectedData, setSelectedData] = useState("FSL Port Blair");
  const [selectedDateOfHandingOver, setSelectedDateOfHandingOver] =
    useState("");
  const [userState] = useState(getStoredUserState);
  const [showPopup, setShowPopup] = useState(false);
  const [showActPopup, setShowActPopup] = useState(false);
  const [showSpecifyActPopup, setShowSpecifyActPopup] = useState(false);
  const [showSectionOfLawPopup, setShowSectionOfLawPopup] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [srNoFilter, setSrNoFilter] = useState("");
  const [sectionMemoNo, setSectionMemoNo] = useState("");
  const [showSubscriptionEndedPopup, setShowSubscriptionEndedPopup] =
    useState(false);
  const [gunaNoFilter, setGunaNoFilter] = useState("");
  const [srNoSortOption, setSrNoSortOption] = useState("");
  const [srNoFilterApplied, setSrNoFilterApplied] = useState(false);
  const [gunaNoFilterApplied, setGunaNoFilterApplied] = useState(false);
  const [showCasePropertyPopup, setShowCasePropertyPopup] = useState(false);
  const [gunaNoSortOption, setGunaNoSortOption] = useState("");
  const [srNoFilterPopupOpen, setSrNoFilterPopupOpen] = useState("");
  const [gunaNoFilterPopupOpen, setGunaNoFilterPopupOpen] = useState("");
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [sortOrder, setSortOrder] = useState("નવીનતમ");
  const [isFormModified, setIsFormModified] = useState(false);
  const [showSpecifyActInput, setShowSpecifyActInput] = useState(false);
  const [selectedAct, setSelectedAct] = useState("");
  const [districtOptions, setDistrictOptions] = useState([]);
  const [subDivisionOptions, setSubDivisionOptions] = useState([]);
  const [stationOptions, setStationOptions] = useState([]);
  const [specifyAct, setSpecifyAct] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState(
    initialStoredScope?.districtId || "",
  );
  const [selectedSubDivisionId, setSelectedSubDivisionId] = useState(
    initialStoredScope?.subDivisionId || "",
  );
  const [selectedStationId, setSelectedStationId] = useState(
    initialStoredScope?.stationId || "",
  );
  const [dateRangeVisible, setDateRangeVisible] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(
    normalizeDateFilterOption(
      localStorage.getItem(RECORDS_FILTER_OPTION_STORAGE_KEY),
    ),
  );
  const [showSectionOfLawInput, setShowSectionOfLawInput] = useState(false);
  const [showPerPage, setShowPerPage] = useState(20);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showInsertDataPopup, setShowInsertDataPopup] = useState(false);
  const [isDataAvailable, setIsDataAvailable] = useState(true); // Default to true (data is available initially)
  const [entryTypes, setEntryTypes] = useState(DEFAULT_ENTRY_TYPE_OPTIONS);
  const [editValidationErrors, setEditValidationErrors] = useState({});
  const [masterActOptions, setMasterActOptions] = useState([]);
  const [masterCasePropertyTypeOptions, setMasterCasePropertyTypeOptions] =
    useState([]);
  const [masterStatusOptions, setMasterStatusOptions] = useState([]);
  const [masterUnitOptions, setMasterUnitOptions] = useState([]);
  const [masterVehicleReasonOptions, setMasterVehicleReasonOptions] = useState(
    [],
  );

  const [isPopupOpen, setPopupOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("case-register-page");

    return () => {
      document.body.classList.remove("case-register-page");
    };
  }, []);

  const [sectionCourtOrderNo, setSectionCourtOrderNo] = useState("");
  const [selectedActRow, setSelectedActRow] = useState(null);
  const [selectedSpecifyActRow, setSelectedSpecifyActRow] = useState(null);
  const [selectedSectionOfLawRow, setSelectedSectionOfLawRow] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [sectionReleased, setSectionReleased] = useState("");
  const [sectionRelesedDate, setSectionRelesedDate] = useState("");
  const [sectionGdNo, setSectionGdNo] = useState("");
  const [sectionOfLaws, setSectionOfLaws] = useState({});
  const [sectionDate, setSectionDate] = useState("");
  const [sectionSentBy, setSectionSentBy] = useState("");
  const [sectionAuctionDate, setSectionAuctionDate] = useState("");
  const [sectionAawarded, setSectionAawarded] = useState("");
  const [sectionAuctionMemoNo, setSectionAuctionMemoNo] = useState("");
  const [sectionAuctionOrderNo, setSectionAuctionOrderNo] = useState("");
  const [sectionExecutiveOrderNo, setSectionExecutiveOrderNo] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [isPopupOpens, setIsPopupOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [sectionOtherStatus, setSectionOtherStatus] = useState("");
  const [isRemarkSet, setIsRemarkSet] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [editingId, setEditingId] = useState(null);
  const [selectedCourtOrderOption, setSelectedCourtOrderOption] =
    useState("Disposed");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [exportOptions, setExportOptions] = useState(INITIAL_EXPORT_OPTIONS);
  // const [focous, setfocous] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [chargeSheetDate, setChargeSheetDate] = useState("");

  const handleDropdownCourtOrderChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCourtOrderOption(selectedValue);
  };

  const loaderStyle = {
    width: "48px",
    height: "48px",
    border: "5px solid #14195d", // Blue color for loader
    borderBottomColor: "transparent",
    borderRadius: "50%",
    position: "absolute",
    top: "50%", // Center vertically
    left: "50%", // Center horizontally
    transform: "translate(-50%, -50%)", // Offset by half of the element's dimensions
    animation: "rotation 1s linear infinite", // Rotation animation
  };

  const containerStyle = {
    position: "fixed", // Fixed positioning to cover the entire screen
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const keyframesStyle = `
    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;

  // const handleChange = (event) => {
  //   setLoading(true)
  //   const value = event.target.value;
  //   setSelectedOption(value);
  //   setIsFormModified(true);

  //   // Store the selected filter option in local storage
  //   localStorage.setItem("selectedFilter", value);

  //   if (value === "custom") {
  //     setDateRangeVisible(true);
  //   } else {
  //     setDateRangeVisible(false);
  //     fetchDateData(value);
  //   }
  // };

  const formatDate89 = (dateString) => {
    if (!dateString) return "NA"; // Return "NA" if no date is provided

    // Parse the date string into a Date object
    const parsedDate = new Date(dateString);

    // If the date is valid, format it as "dd/MM/yyyy"
    if (!isNaN(parsedDate)) {
      return format(parsedDate, "dd/MM/yyyy");
    }

    // Return "NA" if the date is invalid
    return "NA";
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    setIsFormModified(true);

    if (value === "custom") {
      setDateRangeVisible(true);
    } else {
      setDateRangeVisible(false);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
  };

  useEffect(() => {
    setDateRangeVisible(selectedOption === "custom");
  }, [selectedOption]);

  // const handleinputFocous = () => {
  //   setfocous(false);
  // };

  //   const handlePolicesStationChange = async (event) => {
  //   setLoading(true); // Show loader on change
  //   const selectedValue = event.target.value;
  //   setSelectedPolicesStation(selectedValue);

  //   // Perform your fetch or data processing logic here
  //   try {
  //     if (selectedValue === "All") {
  //       const allUserIds = policeStations.map((station) => station.user_id);
  //       await fetchAdminData(allUserIds);
  //     } else {
  //       await fetchAdminData([selectedValue]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false); // Hide loader after data fetching is done
  //   }
  // };

  const clearEditValidationErrors = (...fields) => {
    setEditValidationErrors((prevErrors) => {
      const nextErrors = { ...prevErrors };
      fields.forEach((field) => {
        nextErrors[field] = false;
      });
      return nextErrors;
    });
  };

  const handleEntryTypeChange = (entryTypeCode) => {
    setSelectedData((prevData) =>
      sanitizeRecordForEntryType(
        {
          ...normalizeEntryTypeRecord(prevData, entryTypes),
          entry_type: entryTypeCode,
        },
        entryTypes,
      ),
    );
    clearEditValidationErrors(
      "entry_type",
      "guna_number",
      "receipt_number",
      "other_entry_type",
    );
  };

  const handleEntryTypeFieldChange = (fieldName, value) => {
    setSelectedData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
    clearEditValidationErrors(fieldName);
  };

  const [sectionDisposaldate, setSectionsectionDisposaldate] = useState("");
  const { selectedLanguage } = useContext(LanguageContext);
  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hi: hinTranslations,
    mr: mrTranslations,
  };
  const activeTranslations = {
    ...enTranslations,
    ...(translations[selectedLanguage] || {}),
    ...(UI_TRANSLATIONS[selectedLanguage] || UI_TRANSLATIONS.en),
  };
  const activeCasePropertyTypeOptions = masterCasePropertyTypeOptions;

  // console.log(translations[selectedLanguage]?.guna_number,"vussssal");

  useEffect(() => {
    if (!showEditForm && !showExportPopup) {
      return undefined;
    }

    let isMounted = true;

    const loadMasterOptions = async () => {
      try {
        const [
          casePropertyTypeResponse,
          unitResponse,
          actResponse,
          casePropertyStatusResponse,
          vehicleReasonResponse,
        ] = await Promise.all([
          getMasterDomainItems("case_property_type", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("unit", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("act", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("case_property_status", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("vehicle_reason", {
            lang: selectedLanguage,
            state: userState,
          }),
        ]);

        if (!isMounted) {
          return;
        }

        setMasterCasePropertyTypeOptions(
          buildCasePropertyTypeOptions(casePropertyTypeResponse.items),
        );
        setMasterUnitOptions(buildUnitOptions(unitResponse.items));
        setMasterActOptions(buildActOptions(actResponse.items));
        setMasterStatusOptions(
          buildStatusOptions(casePropertyStatusResponse.items),
        );
        setMasterVehicleReasonOptions(
          buildVehicleReasonOptions(vehicleReasonResponse.items),
        );
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching master dropdown data:", error);
        }
      }
    };

    loadMasterOptions();

    return () => {
      isMounted = false;
    };
  }, [selectedLanguage, showEditForm, showExportPopup, userState]);

  useEffect(() => {
    if (!showEditForm || !selectedData || typeof selectedData !== "object") {
      return;
    }

    if (masterCasePropertyTypeOptions.length > 0) {
      const matchedCasePropertyType = matchOptionValue(
        masterCasePropertyTypeOptions,
        selectedData.muddamaal_type,
      );
      const nextCasePropertyType =
        matchedCasePropertyType ||
        selectedData.muddamaal_type ||
        masterCasePropertyTypeOptions[0]?.value ||
        "";

      if (nextCasePropertyType !== selectedData.muddamaal_type) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                muddamaal_type: nextCasePropertyType,
              }
            : prevData,
        );
      }

      const isVehicleType = isVehicleCasePropertyType(
        nextCasePropertyType,
        masterCasePropertyTypeOptions,
      );
      const matchedVehicleReason = matchOptionValue(
        masterVehicleReasonOptions,
        selectedData.vehicle_reason,
      );
      const nextVehicleReason = isVehicleType
        ? matchedVehicleReason ||
          selectedData.vehicle_reason ||
          masterVehicleReasonOptions[0]?.value ||
          ""
        : "";

      if (nextVehicleReason !== (selectedData.vehicle_reason || "")) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                vehicle_reason: nextVehicleReason,
              }
            : prevData,
        );
      }
    }
  }, [
    masterCasePropertyTypeOptions,
    masterVehicleReasonOptions,
    selectedData,
    showEditForm,
  ]);

  useEffect(() => {
    let isMounted = true;

    const fetchEntryTypes = async () => {
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/entry_types`, {
          headers: {
            Authorization: authKey,
          },
        });

        if (!isMounted) {
          return;
        }

        setEntryTypes(normalizeEntryTypeOptions(response.data));
      } catch (error) {
        console.error("Error fetching entry types:", error);
      }
    };

    fetchEntryTypes();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const showSnackbarMessage = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };
  const translatedText = (key) => activeTranslations[key] ?? key;

  const handleButtonClick = (id) => {
    // Navigate to a new screen or page with the specific id
    navigate(`/new-screen/${id}`);
  };

  const insertRef = useRef(null);

  const handleDeleteFile = (indexToDelete) => {
    setSelectedFiles(
      selectedFiles.filter((_, index) => index !== indexToDelete),
    );
  };

  const handleInsertPopupClose = () => {
    setShowInsertDataPopup(!showInsertDataPopup);
  };

  const fileInputRef = useRef(null);

  const handleUploadButtonClick = () => {
    // Trigger click event of file input when upload button is clicked
    fileInputRef.current.click();
  };

  const handleFileInputChange = (e, documentType) => {
    const files = e.target.files;
    const newFileDetails = Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
      type: documentType,
    }));

    setSelectedFiles([...selectedFiles, ...newFileDetails]);

    setAttachmentFile((prevFiles) => [
      ...(prevFiles || []),
      ...Array.from(files).map((file) => ({ file, type: documentType })),
    ]);
  };
  const handleRemarkChange = (event, id) => {
    setRemark({
      ...remark,
      [id]: event.target.value,
    });
  };

  // const unitOptions = [
  //   { value: "kg", label: "Kilogram (kg)" },
  //   { value: "lb", label: "Pound (lb)" },
  //   { value: "g", label: "Gram (g)" },
  //   { value: "mg", label: "Milligram (mg)" },
  //   { value: "l", label: "Liter (l)" },
  //   { value: "ml", label: "Milliliter (ml)" },
  //   { value: "m", label: "Meter (m)" },
  //   { value: "cm", label: "Centimeter (cm)" },
  //   { value: "mm", label: "Millimeter (mm)" },
  //   { value: "pcs", label: "Pieces (pcs)" },
  // ];

  const handleUnitChange = (event) => {
    const nextUnit = event.target.value;
    setSelectedUnit(nextUnit);
    setSelectedData((prevData) =>
      prevData && typeof prevData === "object"
        ? {
            ...prevData,
            unit: nextUnit,
          }
        : prevData,
    );
  };

  const handleRemarkSet = async (id) => {
    const authKey = localStorage.getItem("authKey");
    const remarkText = remark[id] || "";

    try {
      const config = {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
      };

      // Encode the payload
      const payload = { pendency_reason: remarkText };

      let response;
      if (isRemarkSet[id]) {
        // Update the existing remark
        response = await axios.put(
          `${API_URL}/api/update_pendency_reason/${id}`,
          payload,
          config,
        );
        showSnackbarMessage("Remark updated successfully", "success");
      } else {
        // Add a new remark
        response = await axios.post(
          `${API_URL}/api/add_pendency_reason/${id}`,
          payload,
          config,
        );
        showSnackbarMessage("Remark added successfully", "success");
      }

      // Save the remark to local storage
      const updatedRemarks = { ...remark, [id]: remarkText };
      localStorage.setItem("remarks", JSON.stringify(updatedRemarks));

      // Update state
      setEditingId(null); // Close the input after saving
      setIsRemarkSet((prevState) => ({
        ...prevState,
        [id]: true, // Set the remark as saved
      }));

      // Hide success message after 3 seconds
      setTimeout(() => {
        setIsRemarkSet((prevState) => ({
          ...prevState,
          [id]: false, // Reset the saved status after 3 seconds
        }));
      }, 1000);

      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error(
        "Error setting remark:",
        error.response ? error.response.data : error.message,
      );
      showSnackbarMessage("Error setting remark", "error");
    }
  };

  const handleIconClick = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(true);
  };

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  const closeActButton = () => {
    setShowActPopup(false);
    setSelectedActRow(null);
  };
  const closeSpecifyActButton = () => {
    setShowSpecifyActPopup(false);
    setSelectedSpecifyActRow(null);
  };
  const closeSectionOfLawButton = () => {
    setShowSectionOfLawPopup(false);
    setSelectedSectionOfLawRow(null);
  };
  const closeUpdateButton = () => {
    setShowCasePropertyPopup(false);
  };

  // const fetchUseData = async () => {
  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(`${API_URL}/api/data`, {
  //       headers: {
  //         Authorization: authKey,
  //       },
  //     });

  //     // Check if data exists
  //     if (response.status === 200 && response.data.length > 0) {
  //       setData(response.data);
  //       setFilteredData(response.data);
  //     } else {
  //       setData([]); // Set to an empty array if no data is found
  //       setFilteredData([]);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setData([]); // Set to an empty array on error
  //     setFilteredData([]);
  //   }
  // };

  const fetchUseData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/data`, {
        headers: {
          Authorization: authKey,
        },
      });
      const responseData = ensureArray(response.data);

      if (response.status === 200 && responseData.length > 0) {
        setData(responseData);
        setFilteredData(responseData);
      } else {
        setData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error(error);
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data?.message ===
          "Your subscription has ended. Please contact customer support."
      ) {
        setShowSubscriptionEndedPopup(true);
      }
      setData([]);
      setFilteredData([]);
    }
  };

  const getSelectedScope = () => {
    return buildScopeFromHierarchySelection({
      canSelectDistrict,
      canSelectStation,
      canSelectSubDivision,
      districtId: selectedDistrictId,
      fixedDistrictId,
      fixedStationId,
      fixedSubDivisionId,
      normalizeValue: normalizeScopeId,
      stationId: selectedStationId,
      subDivisionId: selectedSubDivisionId,
    });
  };

  const getSelectedFilters = () => ({
    filterOption: normalizeDateFilterOption(selectedOption),
    startDate: selectedStartDate,
    endDate: selectedEndDate,
  });

  const fetchScopedFilterOptions = async () => {
    if (!canUseAdminHierarchy) {
      setDistrictOptions([]);
      setSubDivisionOptions([]);
      setStationOptions([]);
      return;
    }

    try {
      const selectedScope = getSelectedScope();
      const districtScopeId = selectedScope.districtId || fixedDistrictId;
      const subDivisionScopeId =
        selectedScope.subDivisionId || fixedSubDivisionId;
      const stationParams =
        !canSelectStation && fixedStationId
          ? { station_id: fixedStationId }
          : subDivisionScopeId
            ? {
                sub_division_id: subDivisionScopeId,
                ...(districtScopeId ? { district_id: districtScopeId } : {}),
              }
            : districtScopeId
              ? { district_id: districtScopeId }
              : {};
      const [districtsResult, subDivisionsResult, stationsResult] =
        await Promise.allSettled([
          canSelectDistrict ? getDistricts() : Promise.resolve([]),
          canSelectSubDivision
            ? getSubDivisions(
                districtScopeId ? { district_id: districtScopeId } : {},
              )
            : Promise.resolve([]),
          canSelectStation || fixedStationId
            ? getStations(stationParams)
            : Promise.resolve([]),
        ]);

      const toSettledArray = (result, label) => {
        if (result.status === "fulfilled") {
          return Array.isArray(result.value) ? result.value : [];
        }

        console.error(`Error fetching records ${label}:`, result.reason);
        return [];
      };

      setDistrictOptions(toSettledArray(districtsResult, "district options"));
      setSubDivisionOptions(
        toSettledArray(subDivisionsResult, "sub-division options"),
      );
      setStationOptions(toSettledArray(stationsResult, "station options"));
    } catch (error) {
      console.error("Error fetching records filter options:", error);
      setDistrictOptions([]);
      setSubDivisionOptions([]);
      setStationOptions([]);
    }
  };

  const fetchAdminRecords = async () => {
    const hasActiveFilters =
      Boolean(selectedOption) &&
      (selectedOption !== "custom" || (selectedStartDate && selectedEndDate));

    const nextData = hasActiveFilters
      ? await fetchFilteredCrimeRecords(
          getSelectedScope(),
          getSelectedFilters(),
        )
      : await fetchCrimeBranchRecords(getSelectedScope());

    setData(nextData);
    setFilteredData(nextData);
  };

  const fetchData = async () => {
    if (!isCapabilitiesReady) {
      return;
    }

    setLoading(true);

    try {
      if (canUseAdminHierarchy) {
        await fetchAdminRecords();
      } else {
        await fetchUseData();
      }
    } catch (error) {
      console.error("Error fetching records data:", error);
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data?.message ===
          "Your subscription has ended. Please contact customer support."
      ) {
        setShowSubscriptionEndedPopup(true);
      }
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.setItem(
      RECORDS_HIERARCHY_SCOPE_STORAGE_KEY,
      JSON.stringify({
        districtId: selectedDistrictId,
        subDivisionId: selectedSubDivisionId,
        stationId: selectedStationId,
      }),
    );
  }, [selectedDistrictId, selectedStationId, selectedSubDivisionId]);

  useEffect(() => {
    if (selectedOption) {
      localStorage.setItem(RECORDS_FILTER_OPTION_STORAGE_KEY, selectedOption);
    } else {
      localStorage.removeItem(RECORDS_FILTER_OPTION_STORAGE_KEY);
    }
  }, [selectedOption]);

  useEffect(() => {
    fetchScopedFilterOptions();
  }, [
    canUseAdminHierarchy,
    selectedDistrictId,
    selectedSubDivisionId,
    selectedStationId,
  ]);

  useEffect(() => {
    if (!isCapabilitiesReady) {
      return;
    }

    if (canUseAdminHierarchy && selectedOption === "custom") {
      if (!selectedStartDate || !selectedEndDate) {
        return;
      }
    }

    fetchData();
  }, [
    canUseAdminHierarchy,
    isCapabilitiesReady,
    selectedDistrictId,
    selectedEndDate,
    selectedOption,
    selectedStartDate,
    selectedStationId,
    selectedSubDivisionId,
  ]);

  const districtLabel = resolveSelectedOptionLabel(
    districtOptions,
    fixedDistrictId,
    fixedDistrictId || "Assigned District",
  );
  const subDivisionLabel = resolveSelectedOptionLabel(
    subDivisionOptions,
    fixedSubDivisionId,
    fixedSubDivisionId || "Assigned Sub-division",
  );
  const stationLabel = resolveSelectedOptionLabel(
    stationOptions,
    fixedStationId,
    fixedStationId || "Assigned Police Station",
  );
  const districtFilterOptions = canSelectDistrict
    ? districtOptions
    : ensureFixedOption(districtOptions, fixedDistrictId, districtLabel);
  const subDivisionFilterOptions = canSelectSubDivision
    ? subDivisionOptions
    : ensureFixedOption(
        subDivisionOptions,
        fixedSubDivisionId,
        subDivisionLabel,
      );
  const stationFilterOptions = canSelectStation
    ? stationOptions
    : ensureFixedOption(stationOptions, fixedStationId, stationLabel);
  const displayedDistrictId = canSelectDistrict
    ? selectedDistrictId
    : fixedDistrictId;
  const displayedSubDivisionId = canSelectSubDivision
    ? selectedSubDivisionId
    : fixedSubDivisionId;
  const displayedStationId = canSelectStation
    ? selectedStationId
    : fixedStationId;

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (insertRef.current && !insertRef.current.contains(event.target)) {
        setShowInsertDataPopup(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const filteredOptions = masterActOptions;
  const otherActOption = selectedOptions.find((option) =>
    isOtherActOption(option),
  );
  const otherActOptionName = otherActOption?.name || "Others Acts";
  const getSectionOfLawValue = (optionName, { isOther = false } = {}) =>
    isOther
      ? sectionOfLaws[optionName] || sectionOfLaws["Others Acts"] || ""
      : sectionOfLaws[optionName] || "";

  const countWords = (text) => {
    const words = normalizeTextValue(text).split(/\s+/);
    return words.length;
  };

  const handleSelect = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => isOtherActOption(option)),
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => isOtherActOption(option)),
    );
    setSelectedAct(selectedLawNames);
  };

  const handleRemove = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => isOtherActOption(option)),
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => isOtherActOption(option)),
    );
    setSelectedAct(selectedLawNames);
  };

  const handleSectionOfLawChange = (e, optionName) => {
    setSectionOfLaws({
      ...sectionOfLaws,
      [optionName]: e.target.value,
    });
  };

  const handleSrNoFilterChange = (e) => {
    setSrNoFilter(e.target.value);
  };

  const handleGunaNoFilterChange = (e) => {
    setGunaNoFilter(e.target.value);
  };

  const handleFilterCancel = (column) => {
    if (column === "srNo") {
      setSrNoFilterPopupOpen(false);
      setSrNoSortOption("");
      setSrNoFilterApplied(false);
    } else if (column === "gunaNo") {
      setGunaNoFilterPopupOpen(false);
      setGunaNoSortOption("");
      setGunaNoFilterApplied(false);
    }

    // Add similar logic for other columns
  };
  const handleAttachmentIconClick = (id) => {
    navigate(`/attachment/${id}`, {
      state: {
        from: {
          pathname: `${location.pathname}${location.search}`,
          state: location.state ?? null,
        },
      },
    });
  };
  const handleCoutData = () => {
    navigate(`/View-Date`);
  };
  const handleFilterApply = (column) => {
    // Apply the selected filter options to your data here
    if (column === "srNo") {
      // Apply srNoFilter and srNoSortOption to your data
      setSrNoFilterApplied(true);
      setSrNoFilterPopupOpen(false);
    } else if (column === "gunaNo") {
      setGunaNoFilterApplied(true);
      setGunaNoFilterPopupOpen(false);
    }
  };

  const onPaginationChange = (start, end) => {
    if (pagination.start !== start || pagination.end !== end) {
      setPagination({ start: start, end: end });
    }
  };

  const handleShowPerPageChange = (e) => {
    const selectedShowPerPage = parseInt(e.target.value, 10);
    setShowPerPage(selectedShowPerPage);
    setPagination({ start: 0, end: selectedShowPerPage });
  };

  const openExportPopup = () => {
    setExportOptions({
      ...INITIAL_EXPORT_OPTIONS,
      lang: selectedLanguage,
    });
    setShowExportPopup(true);
  };

  const closeExportPopup = () => {
    if (isExporting) {
      return;
    }

    setShowExportPopup(false);
  };

  const handleExportOptionChange = (fieldName) => (event) => {
    const nextValue = event?.target?.value ?? "";

    setExportOptions((prevOptions) => ({
      ...prevOptions,
      [fieldName]: nextValue,
    }));
  };

  const handleDistrictChange = (event) => {
    const nextDistrictId = event.target.value;
    setSelectedDistrictId(nextDistrictId);
    setSelectedSubDivisionId("");
    setSelectedStationId("");
    setIsFormModified(true);
  };

  const handleSubDivisionChange = (event) => {
    const nextSubDivisionId = event.target.value;
    setSelectedSubDivisionId(nextSubDivisionId);
    setSelectedStationId("");
    setIsFormModified(true);
  };

  const handleStationChange = (event) => {
    setSelectedStationId(event.target.value);
    setIsFormModified(true);
  };

  // Handle police station selection change
  // const handlePolicesStationChange = (event) => {
  //   const selectedValue = event.target.value;
  //   setSelectedPolicesStation(selectedValue);
  //   const isAdmin = localStorage.getItem("admin") === "1";
  //   if (isAdmin) {
  //     if (selectedValue === "All") {
  //       const allUserIds = policeStations.map((station) => station.user_id);
  //       fetchAdminData(allUserIds);
  //       localStorage.setItem("selectedPolicesStation", "All");
  //     } else {
  //       localStorage.setItem("selectedPolicesStation", selectedValue);
  //       fetchAdminData([selectedValue]);
  //     }
  //   } else {
  //     console.log("User is not admin. Cannot fetch combined data.");
  //   }
  // };

  // const fetchData = async () => {
  //   const isAdmin = localStorage.getItem("admin") === "0";
  //   if (!isAdmin) {
  //     console.log("User is not admin. Cannot fetch user access data.");
  //     return;
  //   }
  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(`${API_URL}/api/data`, {
  //       headers: {
  //         Authorization: authKey,
  //       },
  //     });
  //     setData(response.data);
  //     setFilteredData(response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  useEffect(() => {
    const filterTimer = window.setTimeout(() => {
      const filteredRecords = ensureArray(data).filter(
        (row) =>
          Object.values(row || {}).some((value) =>
            safeIncludes(value, searchText),
          ) &&
          matchesDateFilter(
            row,
            selectedOption,
            selectedStartDate,
            selectedEndDate,
          ),
      );

      setFilteredData(sortRecords(filteredRecords, sortOrder));
    }, 180);

    return () => window.clearTimeout(filterTimer);
  }, [
    data,
    searchText,
    selectedEndDate,
    selectedOption,
    selectedStartDate,
    sortOrder,
  ]);

  const handleSortOrderChange = (event) => {
    setSortOrder(event.target.value);
  };
  const handleFilterIconClick = (column) => {
    // Toggle the state of the filter popup for the clicked column
    if (column === "srNo") {
      setSrNoFilterPopupOpen(!srNoFilterPopupOpen);
    } else if (column === "gunaNo") {
      setGunaNoFilterPopupOpen(!gunaNoFilterPopupOpen);
    }
    // Add similar logic for other columns
  };

  const handleDelete = async (id) => {
    try {
      const authKey = localStorage.getItem("authKey");
      await axios.delete(`${API_URL}/api/data/${id}`, {
        headers: {
          Authorization: authKey,
        },
      });
      fetchData();
      setShowDeleteSuccessAlert(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleConfirmDelete = () => {
    handleDelete(deleteItemId);
    setShowDeleteAlert(false);
  };

  const handleDeleteClick = (id) => {
    setDeleteItemId(id);
    setShowDeleteAlert(true);
  };

  const handleCloseDeleteSuccessAlert = () => {
    setShowDeleteSuccessAlert(false);
  };

  const exportCasePropertyData = async () => {
    if (isExporting) {
      return;
    }

    if (
      (exportOptions.startDate && !exportOptions.endDate) ||
      (!exportOptions.startDate && exportOptions.endDate)
    ) {
      showSnackbarMessage(
        "Please select both start date and end date.",
        "error",
      );
      return;
    }

    if (
      exportOptions.startDate &&
      exportOptions.endDate &&
      new Date(exportOptions.startDate) > new Date(exportOptions.endDate)
    ) {
      showSnackbarMessage("Start date cannot be after end date.", "error");
      return;
    }

    setIsExporting(true);

    try {
      const response = await exportCrimeData({
        entryType: exportOptions.entryType,
        filters:
          exportOptions.startDate && exportOptions.endDate
            ? {
                startDate: exportOptions.startDate,
                endDate: exportOptions.endDate,
              }
            : {},
        format: exportOptions.format,
        lang: exportOptions.lang,
        scope: getSelectedScope(),
        status: exportOptions.status,
      });
      const blob =
        response?.data instanceof Blob
          ? response.data
          : new Blob([response?.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");

      downloadLink.href = downloadUrl;
      downloadLink.download = extractFilenameFromHeaders(response?.headers);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.URL.revokeObjectURL(downloadUrl);
      setShowExportPopup(false);
      showSnackbarMessage("Records exported successfully.", "success");
    } catch (error) {
      console.error("Error exporting case property records:", error);
      const errorMessage =
        error?.response?.status === 404
          ? "No records found for the selected export filters."
          : "Unable to export records with the selected filters.";
      showSnackbarMessage(errorMessage, "error");
    } finally {
      setIsExporting(false);
    }
  };

  const handleEditClose = () => {
    setShowEditForm(false);
  };
  const handleView = (id) => {
    const selectedDataRow = filteredData.find((row) => row.id === id);
    setSelectedData(selectedDataRow);
    setShowPopup(true);
    setShowEditForm(false);
  };

  // const handleEditClick = async (row) => {
  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(`${API_URL}/api/data/${row.id}`, {
  //       headers: {
  //         Authorization: authKey,
  //       },
  //     });
  //     const rowData = response.data;

  //     // Parse the section_of_law JSON string
  //     const sectionOfLawsData = JSON.parse(rowData.section_of_law);

  //     // Convert charge_sheet_date and next_court_date to Date objects if they exist
  //     const chargeSheetDate = rowData.charge_sheet_date
  //       ? new Date(rowData.charge_sheet_date)
  //       : null;
  //     const nextCourtDate = rowData.next_court_date
  //       ? new Date(rowData.next_court_date)
  //       : null;

  //     setSelectedData({
  //       ...row,
  //       act: rowData.act || "",
  //       section_of_law: rowData.section_of_law || "",
  //       specify_act: rowData.specify_act || "",
  //       charge_sheet_date: chargeSheetDate,
  //       next_court_date: nextCourtDate,
  //     });

  //     // Set selected options for acts dropdown
  //     if (rowData.act && rowData.act.trim() !== "") {
  //       const selectedOptionsData = rowData.act.split(", ").map((name) => ({
  //         name,
  //       }));
  //       setSelectedOptions(selectedOptionsData);
  //     } else {
  //       setSelectedOptions([]);
  //     }

  //     // Set specifyAct state
  //     setSpecifyAct(rowData.specify_act || "");

  //     // Set sectionOfLaws state
  //     setSectionOfLaws(sectionOfLawsData);

  //     // Hide popup and show edit form
  //     setShowPopup(false);
  //     setShowEditForm(true);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleEditClick = async (row) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/data/${row.id}`, {
        headers: {
          Authorization: authKey,
        },
      });
      const rowData = response.data;

      // Parse the section_of_law JSON string
      const sectionOfLawsData = JSON.parse(rowData.section_of_law);

      // Handle charge_sheet_date and next_court_date safely
      const chartSheetDate = rowData.chart_sheet_date
        ? new Date(rowData.chart_sheet_date)
        : null;
      const nextCourtDate = rowData.next_court_date
        ? new Date(rowData.next_court_date)
        : null;
      const normalizedUnit = matchOptionValue(
        masterUnitOptions,
        rowData.unit || row.unit || "",
      );
      const normalizedCasePropertyType = matchOptionValue(
        masterCasePropertyTypeOptions,
        rowData.muddamaal_type || row.muddamaal_type || "",
      );
      const normalizedVehicleReason = matchOptionValue(
        masterVehicleReasonOptions,
        rowData.vehicle_reason || row.vehicle_reason || "",
      );
      const normalizedStatus = matchOptionValue(
        masterStatusOptions,
        rowData.status_of_muddamaal || row.status_of_muddamaal || "",
      );

      setSelectedData(
        normalizeEntryTypeRecord(
          {
            ...row,
            act: rowData.act || "",
            section_of_law: rowData.section_of_law || "",
            specify_act: rowData.specify_act || "",
            chart_sheet_date: chartSheetDate,
            next_court_date: nextCourtDate,
            muddamaal_type:
              normalizedCasePropertyType ||
              rowData.muddamaal_type ||
              row.muddamaal_type ||
              "",
            vehicle_reason:
              normalizedVehicleReason ||
              rowData.vehicle_reason ||
              row.vehicle_reason ||
              "",
            unit: normalizedUnit || rowData.unit || row.unit || "",
            status_of_muddamaal:
              normalizedStatus ||
              rowData.status_of_muddamaal ||
              row.status_of_muddamaal ||
              "",
          },
          entryTypes,
        ),
      );

      // Set selected options for acts dropdown
      if (rowData.act && rowData.act.trim() !== "") {
        let selectedOptionsData = matchActOptionsByNames(
          rowData.act,
          masterActOptions,
        );

        if (rowData.specify_act?.trim()) {
          const otherMasterOption = masterActOptions.find((option) =>
            isOtherActOption(option),
          );
          const isStoredAsSpecifyActOnly =
            rowData.act.trim() === rowData.specify_act.trim();

          if (otherMasterOption && isStoredAsSpecifyActOnly) {
            selectedOptionsData = [otherMasterOption];
          }
        }

        setSelectedOptions(selectedOptionsData);
        const hasOtherActSelected = selectedOptionsData.some((option) =>
          isOtherActOption(option),
        );
        setShowSpecifyActInput(hasOtherActSelected);
        setShowSectionOfLawInput(!hasOtherActSelected);
        setSelectedAct(
          hasOtherActSelected
            ? rowData.specify_act || ""
            : selectedOptionsData.map((option) => option.name).join(", "),
        );
      } else {
        setSelectedOptions([]);
        setShowSpecifyActInput(false);
        setShowSectionOfLawInput(false);
        setSelectedAct("");
      }

      // Set specifyAct state
      setSpecifyAct(rowData.specify_act || "");
      setSelectedUnit(normalizedUnit || rowData.unit || row.unit || "");

      // Set sectionOfLaws state
      setSectionOfLaws(sectionOfLawsData);
      setEditValidationErrors({});

      // Hide popup and show edit form
      setShowPopup(false);
      setShowEditForm(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClosePopup = () => {
    setSelectedData(null);
    setShowPopup(false);
  };

  const handleDisposalFileInputChange = (e) =>
    handleFileInputChange(e, "disposal");
  const handleAuctionFileInputChange = (e) =>
    handleFileInputChange(e, "auction");
  const handleHandedOverFileInputChange = (e) =>
    handleFileInputChange(e, "handedOver");
  const handleCourtOrderFileInputChange = (e) =>
    handleFileInputChange(e, "courtOrder");

  // const handleEditSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const sectionOfLawsObject = {};
  //     for (const option of selectedOptions) {
  //       sectionOfLawsObject[option.name] = sectionOfLaws[option.name] || "";
  //     }
  //     // Include the new_status_of_muddamaal in the selectedData
  //     const updatedData = {
  //       ...selectedData,
  //       act: selectedAct,
  //       specify_act: specifyAct,
  //       section_of_law: JSON.stringify(sectionOfLawsObject),
  //       unit: selectedUnit,
  //     };

  //     await axios.put(`${API_URL}/api/data/${selectedData.id}`, updatedData, {
  //       headers: {
  //         Authorization: authKey,
  //       },
  //     });
  //     setSelectedData(null);
  //     setShowEditForm(false);
  //     fetchData();
  //     setSnackbarMessage("Data updated successfully!");
  //     setOpenSnackbar(true);

  //     setTimeout(() => {
  //       setOpenSnackbar(false);
  //     }, 1000);
  //   } catch (error) {
  //     console.error("Error updating main crime data:", error);
  //   }
  // };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const authKey = localStorage.getItem("authKey");
      const nextEntryTypeErrors = buildEntryTypeValidationErrors(
        selectedData,
        entryTypes,
      );

      if (Object.values(nextEntryTypeErrors).some(Boolean)) {
        setEditValidationErrors(nextEntryTypeErrors);
        showSnackbarMessage("Please fill in all required fields.", "error");
        return;
      }

      const hasOtherActSelected = selectedOptions.some((option) =>
        isOtherActOption(option),
      );

      // Construct sectionOfLawsObject
      const sectionOfLawsObject = {};
      for (const option of selectedOptions) {
        sectionOfLawsObject[option.name] = getSectionOfLawValue(option.name, {
          isOther: isOtherActOption(option),
        });
      }

      // Helper function to format date to 'YYYY-MM-DD'
      const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      // Include charge_sheet_date and next_court_date formatted as 'YYYY-MM-DD'
      const updatedData = {
        ...sanitizeRecordForEntryType(selectedData, entryTypes),
        act: hasOtherActSelected
          ? specifyAct.trim()
          : selectedOptions.map((option) => option.name).join(", "),
        specify_act: specifyAct,
        section_of_law: JSON.stringify(sectionOfLawsObject),
        unit: selectedUnit,
        chart_sheet_date: formatDate(selectedData.chart_sheet_date),
        next_court_date: formatDate(selectedData.next_court_date),
      };

      // API call to update the data
      await axios.put(`${API_URL}/api/data/${selectedData.id}`, updatedData, {
        headers: {
          Authorization: authKey,
        },
      });

      // Reset form states and fetch updated data
      setSelectedData(null);
      setShowEditForm(false);
      fetchData();

      // Show success notification
      showSnackbarMessage("Data updated successfully!", "success");
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating main crime data:", error);
    }
  };

  useEffect(() => {
    if (!showEditForm || !selectedData || typeof selectedData !== "object") {
      return;
    }

    if (masterActOptions.length > 0 && selectedData.act) {
      let matchedOptions = matchActOptionsByNames(
        selectedData.act,
        masterActOptions,
      );

      if (selectedData.specify_act?.trim()) {
        const otherMasterOption = masterActOptions.find((option) =>
          isOtherActOption(option),
        );
        const isStoredAsSpecifyActOnly =
          selectedData.act.trim() === selectedData.specify_act.trim();

        if (otherMasterOption && isStoredAsSpecifyActOnly) {
          matchedOptions = [otherMasterOption];
        }
      }

      const hasOtherActSelected = matchedOptions.some((option) =>
        isOtherActOption(option),
      );

      setSelectedOptions(matchedOptions);
      setShowSpecifyActInput(hasOtherActSelected);
      setShowSectionOfLawInput(!hasOtherActSelected);
      setSelectedAct(
        hasOtherActSelected
          ? selectedData.specify_act || ""
          : matchedOptions.map((option) => option.name).join(", "),
      );
    }

    if (masterUnitOptions.length > 0) {
      const matchedUnit = matchOptionValue(
        masterUnitOptions,
        selectedData.unit || selectedUnit,
      );

      if (matchedUnit && matchedUnit !== selectedUnit) {
        setSelectedUnit(matchedUnit);
      }

      if (matchedUnit && matchedUnit !== selectedData.unit) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                unit: matchedUnit,
              }
            : prevData,
        );
      }
    }

    if (masterStatusOptions.length > 0) {
      const matchedStatus = matchOptionValue(
        masterStatusOptions,
        selectedData.status_of_muddamaal,
      );

      if (matchedStatus && matchedStatus !== selectedData.status_of_muddamaal) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                status_of_muddamaal: matchedStatus,
              }
            : prevData,
        );
      }
    }
  }, [
    masterActOptions,
    masterStatusOptions,
    masterUnitOptions,
    selectedData,
    selectedUnit,
    showEditForm,
  ]);

  const updateStatusDetails = async (e) => {
    e.preventDefault();
    try {
      const authKey = localStorage.getItem("authKey");
      const newStatusOfMuddamaal = selectedData.new_status_of_muddamaal;

      const statusDetailsData = {
        ...selectedData,
        new_status_of_muddamaal: newStatusOfMuddamaal,
        court_order_no: sectionCourtOrderNo,
        released_to_whom: sectionReleased,
        release_date: sectionRelesedDate,
        gd_no: sectionGdNo,
        date: sectionDate,
        cfslName: sectionCfslName,
        sentBy: sectionSentBy,
        other_status_case_property: sectionOtherStatus,
        auctionDate: sectionAuctionDate,
        executiveOrder: sectionExecutiveOrderNo,
        disposalDate: sectionDisposaldate,
        auctionOrderNo: sectionAuctionOrderNo,
        awarded: sectionAawarded,
        auctionMemoNo: sectionAuctionMemoNo,
        memoNo: sectionMemoNo,
        dateOfHandingOver: selectedDateOfHandingOver,
        paymentMode: selectedPaymentMode,
        disposalOnCourt: selectedCourtOrderOption,
      };

      // Create a FormData object
      const formData = new FormData();

      // Append the form fields to the FormData object
      Object.keys(statusDetailsData).forEach((key) => {
        formData.append(key, statusDetailsData[key]);
      });

      // Append the attachments with size and type
      if (attachmentFile && attachmentFile.length > 0) {
        attachmentFile.forEach(({ file, type }) => {
          formData.append("Attachment", file);
          formData.append("FileSize", file.size);
          formData.append("DocumentType", type);
        });
      }

      // Make the PUT request to update status details
      await axios.put(
        `${API_URL}/api/custody_log_status/${selectedData.id}`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data", // Important for sending FormData
          },
        },
      );

      // Reset UI state after successful update
      setShowCasePropertyPopup(false);
      fetchData();

      // Show success message in Snackbar
      showSnackbarMessage("Data updated successfully!", "success");

      // Hide Snackbar after 1 second
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating status details:", error);
    }
  };

  const handleFilterChange = (event) => {
    setSearchText(event.target.value);
  };

  const generateHighlightedText = (text, searchText) => {
    if (!searchText || searchText === "" || typeof text !== "string") {
      return text;
    }
    const regex = new RegExp(searchText, "gi");
    return text.replace(regex, (match) => `<mark>${match}</mark>`);
  };

  const optionss = [
    { value: "last_week", label: translatedText("last_week") },
    { value: "last_month", label: translatedText("last_month_period") },
    {
      value: "last_three_months",
      label: translatedText("last_three_months"),
    },
    {
      value: "last_six_months",
      label: translatedText("last_six_months"),
    },
    { value: "custom", label: translatedText("custom_date") },
  ];

  // function formatDate(inputDate) {
  //   const options = {
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //   };

  //   const date = new Date(inputDate);

  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  //   const year = date.getFullYear();

  //   const formattedDate = `${day}/${month}/${year}`;
  //   return formattedDate;
  // }
  function formatDate(inputDate) {
    if (!inputDate) return "NA"; // Return "NA" if inputDate is null, undefined, or empty

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return "NA"; // Check for an invalid date

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function formatDates(inputDate) {
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "UTC",
    };

    const date = new Date(inputDate);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formattedDate;
  }
  // const resetForm = () => {
  //   // setSelectedPoliceStation('');
  //   setSelectedOption("");
  //   setSelectedStartDate(null);
  //   setSelectedEndDate(null);
  //   setDateRangeVisible(false);
  //   setIsFormModified(false);
  //   // fetchCombinedData('');
  //   fetchAdminData(""); // Fetch data with cleared fields or default parameters
  // };

  const handleChargeSheetDateChange = (date) => {
    setSelectedData((prevData) => ({
      ...prevData,
      date_of_seizure: date.toISOString(),
    }));
  };
  const handleNextCourtDateChange = (date) => {
    setSelectedData((prevData) => ({
      ...prevData,
      next_court_date: date.toISOString(),
    }));
  };

  // const resetForm = () => {
  //   // Reset filters and form state
  //   setSelectedPolicesStation(""); // Clear selected police station
  //   setSelectedOption(""); // Clear selected option
  //   setSelectedStartDate(null); // Clear start date
  //   setSelectedEndDate(null); // Clear end date
  //   setDateRangeVisible(false); // Hide date range picker
  //   setIsFormModified(false); // Mark form as unmodified

  //   // Remove stored values from local storage if any
  //   // localStorage.removeItem("selectedPoliceStation");
  //   localStorage.removeItem("selectedFilter");

  //   // Call fetchAdminData with empty or default values
  //   fetchAdminData([]);
  // };
  const resetForm = async () => {
    setSelectedDistrictId("");
    setSelectedSubDivisionId("");
    setSelectedStationId("");
    setSelectedOption("");
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setDateRangeVisible(false);
    setIsFormModified(false);
    localStorage.removeItem(RECORDS_FILTER_OPTION_STORAGE_KEY);
    localStorage.removeItem(RECORDS_HIERARCHY_SCOPE_STORAGE_KEY);
  };
  // const Tooltip = styled(({ className, ...props }) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))(({ theme }) => ({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     backgroundColor: theme.palette.common.white,
  //     color: 'rgba(0, 0, 0, 0.87)',
  //     boxShadow: theme.shadows[1],
  //     fontSize: 11,
  //   },
  // }));

  // Function to truncate text by word limit
  const truncateTextByWordLimit = (text, wordLimit = 5) => {
    const safeText = normalizeTextValue(text);
    const words = safeText.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..." // Truncate and add ellipsis
      : safeText; // Return original text if within limit
  };

  function truncateText(text) {
    const safeText = normalizeTextValue(text);
    // Split the text into words
    const words = safeText.split(" ");

    // Check if there is only one word
    if (words.length === 1) {
      return safeText; // Return the full word if it's a single word
    }

    return words[0]; // Return the first word
  }

  const visibleRegisterRows = ensureArray(filteredData)
    .filter((row) => safeIncludes(row.serial_number, srNoFilter))
    .sort((a, b) => {
      if (srNoSortOption === "az") {
        return String(a.serial_number ?? "").localeCompare(
          String(b.serial_number ?? ""),
        );
      }

      if (srNoSortOption === "za") {
        return String(b.serial_number ?? "").localeCompare(
          String(a.serial_number ?? ""),
        );
      }

      return 0;
    })
    .slice(pagination.start, pagination.end);

  return (
    <>
      <Navbar />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <div className="datalist-main-container datalist-fit-layout new_datalist-layout">
        <div className="datalist-main-container-header new_datalist-header">
          <div className="datalist-left-side-header new_datalist-header-group new_datalist-header-group--left">
            <div className="new_datalist-control-group new_datalist-control-group--search">
              <label
                className="new_datalist-control-label new_datalist-visually-hidden"
                htmlFor="filterInput"
              >
                {translatedText("search_records")}
              </label>
              <div className="search-bar new_datalist-search">
                <div className="input-container">
                  <FiSearch
                    aria-hidden="true"
                    className="new_datalist-search-icon"
                  />
                  <input
                    type="text"
                    id="filterInput"
                    value={searchText}
                    onChange={handleFilterChange}
                    placeholder={translatedText("search_placeholder")}
                  />
                </div>
              </div>
            </div>
            <div className="new_datalist-control-group new_datalist-control-group--sort">
              <span className="new_datalist-control-label new_datalist-visually-hidden">
                {translatedText("sort_records")}
              </span>
              <div className="sort-bar new_datalist-sort">
                <MdSort aria-hidden="true" className="new_datalist-sort-icon" />
                <SearchableSelect
                  value={sortOrder}
                  onChange={handleSortOrderChange}
                  searchPlaceholder={translatedText("search_sort_options")}
                >
                  <option value="નવીનતમ">
                    {translatedText("latest_first")}
                  </option>
                  <option value="જૂના">{translatedText("oldest_first")}</option>
                  <option value="AtoZ">{translatedText("sort_a_to_z")}</option>
                  <option value="ZtoA">{translatedText("sort_z_to_a")}</option>
                  <option value="તારીખ">{translatedText("date")}</option>
                  <option value="સરનો">
                    {translatedText("serial_number")}
                  </option>
                  <option value="ગુના_નો">
                    {translatedText("guna_number")}
                  </option>
                  <option value="તારીખ_જપ્ત_કર્યા_ની">
                    {translatedText("date_of_seizure")}
                  </option>
                  <option value="મુદ્દામાલ_પાવતી_નો">
                    {translatedText("exhibit_number")}
                  </option>
                  <option value="જથ્થો">{translatedText("quantity")}</option>
                  <option value="કિંમત">{translatedText("price")}</option>
                </SearchableSelect>
              </div>
            </div>
          </div>
          <div className="datalist-center-side-header new_datalist-filter-region">
            <div className="police-dropdown-list new_datalist-filter-shell">
              <div className="police-dropdowns-list new_datalist-filter-inner">
                <HierarchyFilterBar
                  className="new_report-filter-bar"
                  compact
                  districtDisabled={!canSelectDistrict}
                  districtOptions={districtFilterOptions}
                  selectedDistrictId={displayedDistrictId}
                  selectedDistrictLabel={districtLabel}
                  selectedStationId={displayedStationId}
                  selectedStationLabel={stationLabel}
                  selectedSubDivisionId={displayedSubDivisionId}
                  selectedSubDivisionLabel={subDivisionLabel}
                  stationDisabled={!canSelectStation}
                  stationOptions={stationFilterOptions}
                  subDivisionDisabled={!canSelectSubDivision}
                  subDivisionOptions={subDivisionFilterOptions}
                  showDistrictFilter={showDistrictField}
                  showSubDivisionFilter={showSubDivisionField}
                  showStationFilter={showStationField}
                  selectedFilterOption={selectedOption}
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate}
                  hideDateFilterLabel
                  onDistrictChange={handleDistrictChange}
                  onSubDivisionChange={handleSubDivisionChange}
                  onStationChange={handleStationChange}
                  onFilterOptionChange={handleChange}
                  onDateRangeChange={(dates) => {
                    const [start, end] = dates;
                    setSelectedStartDate(start);
                    setSelectedEndDate(end);
                    setIsFormModified(true);
                  }}
                  onReset={resetForm}
                  quickFilterOptions={optionss}
                  showDateFilters
                  showReset={isFormModified}
                  translate={translatedText}
                />
              </div>
            </div>
          </div>

          <div className="datalist-right-side-header new_datalist-header-group new_datalist-header-group--right">
            <div className="export-btn new_datalist-secondary-action">
              <button
                aria-label={translatedText("export_records")}
                disabled={isExporting}
                onClick={openExportPopup}
                type="button"
              >
                {isExporting
                  ? translatedText("loading")
                  : translatedText("export_records")}
              </button>
            </div>
            <div className="muddamal-btn new_datalist-primary-action">
              {can("crime_data", "create") && (
                <button onClick={() => handleInsertPopupClose()} type="button">
                  <FiPlus aria-hidden="true" />
                  <span>{translatedText("add_case_property")}</span>
                </button>
              )}
            </div>
          </div>
        </div>
        <style>{keyframesStyle}</style>
        <div className="datalist-main-container-body new_datalist-body new_datalist-body--register">
          <CasePropertyTable
            canEdit={canUpdateCrimeData}
            canView={canReadCrimeData}
            loading={loading}
            onAttachment={(row) => handleAttachmentIconClick(row.id)}
            onCustody={(row) => handleButtonClick(row.id)}
            onEdit={handleEditClick}
            onView={(row) => handleView(row.id)}
            rows={visibleRegisterRows}
            translate={translatedText}
          />
        </div>
        {false &&
          (loading ? (
            <div style={containerStyle}>
              <div style={loaderStyle}></div>
            </div>
          ) : (
            <>
              {filteredData.length > 0 ? (
                <div className="datalist-main-container-body new_datalist-body">
                  <div className="datalist-scroll-body new_datalist-scroll-body">
                    <div className="data-list-table container50 data-list-table--fit new_datalist-table-shell">
                      <table className="tables tables--fit new_datalist-table">
                        <thead className="data-list-table-header new_datalist-table-head">
                          <tr>
                            <th>
                              {translatedText("sr_no")}
                              <span
                                className="filter-icon"
                                onClick={() => handleFilterIconClick("srNo")}
                              >
                                <CgArrowsScrollV className="icon-filter" />
                              </span>
                              {srNoFilterPopupOpen && (
                                <div className="filter-popup">
                                  <input
                                    type="text"
                                    className="search-text"
                                    value={srNoFilter}
                                    onChange={handleSrNoFilterChange}
                                    placeholder="Filter Sr. No"
                                  />
                                  <div className="filter-options">
                                    <label>
                                      <input
                                        type="radio"
                                        name="sortOption"
                                        value="az"
                                        checked={srNoSortOption === "az"}
                                        onChange={() => setSrNoSortOption("az")}
                                      />
                                      Sort by A to Z
                                    </label>
                                    <label>
                                      <input
                                        type="radio"
                                        name="sortOption"
                                        value="za"
                                        checked={srNoSortOption === "za"}
                                        onChange={() => setSrNoSortOption("za")}
                                      />
                                      Sort by Z to A
                                    </label>
                                    <label>
                                      <input
                                        type="radio"
                                        name="sortOption"
                                        value="values"
                                        checked={srNoSortOption === "values"}
                                        onChange={() =>
                                          setSrNoSortOption("values")
                                        }
                                      />
                                      Sort by Values
                                    </label>
                                  </div>
                                  <div className="filter-buttons">
                                    <button
                                      onClick={() => handleFilterCancel("srNo")}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={() => handleFilterApply("srNo")}
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              )}
                            </th>

                            {(userState === "Andaman and Nicobar" ||
                              userState === "Maharashtra" ||
                              userState === "Goa") && (
                              <th className="new_datalist-column--detail">
                                {translatedText("exhibit_number")}
                              </th>
                            )}

                            <th>
                              {translatedText("guna_number")}
                              <span
                                className="filter-icon"
                                onClick={() => handleFilterIconClick("gunaNo")}
                              >
                                <CgArrowsScrollV className="icon-filter" />
                              </span>
                              {gunaNoFilterPopupOpen && (
                                <div className="filter-popup">
                                  <input
                                    type="text"
                                    className="search-text"
                                    value={gunaNoFilter}
                                    onChange={handleGunaNoFilterChange}
                                    placeholder="Filter Sr. No"
                                  />
                                  <div className="filter-options">
                                    <label>
                                      <input
                                        type="radio"
                                        name="sortOption"
                                        value="az"
                                        checked={gunaNoSortOption === "az"}
                                        onChange={() =>
                                          setGunaNoSortOption("az")
                                        }
                                      />
                                      Sort by A to Z
                                    </label>
                                    <label>
                                      <input
                                        type="radio"
                                        name="sortOption"
                                        value="za"
                                        checked={gunaNoSortOption === "za"}
                                        onChange={() =>
                                          setGunaNoSortOption("za")
                                        }
                                      />
                                      Sort by Z to A
                                    </label>
                                    <label>
                                      <input
                                        type="radio"
                                        name="sortOption"
                                        value="values"
                                        checked={gunaNoSortOption === "values"}
                                        onChange={() =>
                                          setGunaNoSortOption("values")
                                        }
                                      />
                                      Sort by Values
                                    </label>
                                  </div>
                                  <div className="filter-buttons">
                                    <button
                                      onClick={() =>
                                        handleFilterCancel("gunaNo")
                                      }
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleFilterApply("gunaNo")
                                      }
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              )}
                            </th>
                            <th className="new_datalist-date-column">
                              {translatedText("date_of_seizure")}
                            </th>
                            {userState === "Gujarat" && (
                              <th className="new_datalist-column--detail">
                                {translatedText("exhibit_number")}
                              </th>
                            )}
                            <th className="new_datalist-type-column">
                              {translatedText("muddamaal_type")}
                            </th>
                            <th className="new_datalist-quantity-column">
                              {translatedText("quantity")} /{" "}
                              {translatedText("unit")}
                            </th>
                            {userState === "Gujarat" && (
                              <th className="new_datalist-price-column">
                                {translatedText("price")}
                              </th>
                            )}
                            <th>{translatedText("status_of_muddamaal")}</th>
                            <th className="new_datalist-column--detail">
                              {translatedText("updated_on")}
                            </th>
                            <th className="new_datalist-column--detail">
                              {translatedText("act_section_of_low")}
                            </th>
                            <th className="new_datalist-column--detail">
                              {translatedText("description")}
                            </th>
                            <th className="new_datalist-column--detail">
                              {translatedText("chart_sheet_date")}
                            </th>
                            <th className="new_datalist-column--detail">
                              {translatedText("next_court_date")}
                            </th>
                            <th className="clms1 new_datalist-column--detail">
                              {translatedText("reason_for_pendency")}
                            </th>
                            <th className="new_datalist-attachment-cell">
                              {translatedText("attachment")}
                            </th>
                            <th>{translatedText("action")}</th>
                          </tr>
                        </thead>
                        <tbody className="data-list-table-body new_datalist-table-body">
                          {ensureArray(filteredData)
                            .filter(
                              (row) =>
                                safeIncludes(row.serial_number, srNoFilter),
                              // Add similar conditions for other filterable columns
                            )
                            .sort((a, b) => {
                              if (srNoSortOption === "az") {
                                return a.serial_number.localeCompare(
                                  b.serial_number,
                                );
                              } else if (srNoSortOption === "za") {
                                return b.serial_number.localeCompare(
                                  a.serial_number,
                                );
                              } else {
                                // Handle sorting by values (you may need to modify this logic)
                                return 0;
                              }
                            })
                            .slice(pagination.start, pagination.end)
                            .map((row) => (
                              <tr key={row.id}>
                                <td
                                  className="clm1"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      row.serial_number,
                                      searchText,
                                    ),
                                  }}
                                />
                                {(userState === "Andaman and Nicobar" ||
                                  userState === "Maharashtra" ||
                                  userState === "Goa") && (
                                  <td
                                    className="clm4 new_datalist-column--detail"
                                    dangerouslySetInnerHTML={{
                                      __html: generateHighlightedText(
                                        row.exhibit_number || "NA",
                                        searchText,
                                      ),
                                    }}
                                  />
                                )}

                                <td
                                  className="clm2"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      row.guna_number || "NA",
                                      searchText,
                                    ),
                                  }}
                                />
                                <td
                                  className="clm3 new_datalist-date-column"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      formatDate(row.date_of_seizure || "NA"),
                                      searchText,
                                    ),
                                  }}
                                />
                                {userState === "Gujarat" && (
                                  <td
                                    className="clm4 new_datalist-column--detail"
                                    dangerouslySetInnerHTML={{
                                      __html: generateHighlightedText(
                                        row.exhibit_number || "NA",
                                        searchText,
                                      ),
                                    }}
                                  />
                                )}
                                {/* <td
                                  className={`clm5 ${row.muddamaal_type === "અન્ય" ||
                                      row.muddamaal_type === "Others"
                                      ? "bg-color-1"
                                      : row.muddamaal_type ===
                                        "ડ્રગ્સ & નાર્કોટિક્સ" ||
                                        row.muddamaal_type ===
                                        "Drugs & Narcotics"
                                        ? "bg-color-2"
                                        : row.muddamaal_type ===
                                          "સાંસ્કૃતિક મિલકત" ||
                                          row.muddamaal_type ===
                                          "Cultural Heritage"
                                          ? "bg-color-3"
                                          : row.muddamaal_type === "ચલણી નાણું" ||
                                            row.muddamaal_type ===
                                            "Counterfeit Currency"
                                            ? "bg-color-4"
                                            : row.muddamaal_type === "અગ્નિ હથિયાર" ||
                                              row.muddamaal_type === "Firearms"
                                              ? "bg-color-5"
                                              : row.muddamaal_type === "અન્ય હથિયાર" ||
                                                row.muddamaal_type === "Other Weapons"
                                                ? "bg-color-6"
                                                : row.muddamaal_type === "પ્રોહિબીશન" ||
                                                  row.muddamaal_type === "Prohibition"
                                                  ? "bg-color-7"
                                                  : row.muddamaal_type === "સોનું" ||
                                                    row.muddamaal_type === "Gold"
                                                    ? "bg-color-8"
                                                    : row.muddamaal_type === "ઘરેણાં" ||
                                                      row.muddamaal_type === "Jewellery"
                                                      ? "bg-color-9"
                                                      : row.muddamaal_type ===
                                                        "બિનવારસી મુદ્દામાલ" ||
                                                        row.muddamaal_type ===
                                                        "Unclaimed Property"
                                                        ? "bg-color-10"
                                                        : row.muddamaal_type ===
                                                          "બનાવટી ચલણી નાણું" ||
                                                          row.muddamaal_type ===
                                                          "Counterfeit Currency"
                                                          ? "bg-color-11"
                                                          : row.muddamaal_type ===
                                                            "મોબાઈલ અને ઇલેક્ટ્રોનિક ઇકવિપમેન્ટ" ||
                                                            row.muddamaal_type ===
                                                            "Mobile and Electronic Equipment"
                                                            ? "bg-color-12"
                                                            : row.muddamaal_type === "IMFL" ||
                                                              row.muddamaal_type === "IMFL"
                                                              ? "bg-color-6"
                                                              : row.muddamaal_type ===
                                                                "Gold and Jewellery" ||
                                                                row.muddamaal_type ===
                                                                "Gold and Jewellery"
                                                                ? "bg-color-3"
                                                                : row.muddamaal_type ===
                                                                  "Illicit liquor" ||
                                                                  row.muddamaal_type === "Illicit liquor"
                                                                  ? "bg-color-4"
                                                                  : row.muddamaal_type === "Handia" ||
                                                                    row.muddamaal_type === "Handia"
                                                                    ? "bg-color-5"
                                                                    : row.muddamaal_type ===
                                                                      "Counterfeit Goods" ||
                                                                      row.muddamaal_type ===
                                                                      "Counterfeit Goods"
                                                                      ? "bg-color-10"
                                                                      : row.muddamaal_type === "વાહન" ||
                                                                        row.muddamaal_type === "Vehicle"
                                                                        ? "bg-color-133"
                                                                        : ""
                                    } ${row.muddamaal_type === "વાહન" ||
                                      row.muddamaal_type === "Vehicle"
                                      ? "bg-color-black"
                                      : ""
                                    } ${row.muddamaal_type === "વાહન" ||
                                      (row.muddamaal_type === "Vehicle" &&
                                        row.muddamaal_type === "વાહન") ||
                                      (row.muddamaal_type === "Vehicle" &&
                                        row.vehicle_reason === "ડીટેઇન્ડ") ||
                                      row.vehicle_reason === "Detained"
                                      ? "yellow"
                                      : row.muddamaal_type === "વાહન" ||
                                        (row.muddamaal_type === "Vehicle" &&
                                          row.vehicle_reason === "ગુના કામે") ||
                                        row.vehicle_reason === "Gun Kaame"
                                        ? "red"
                                        : row.muddamaal_type === "વાહન" ||
                                          (row.muddamaal_type === "Vehicle" &&
                                            row.vehicle_reason ===
                                            "સ્ટે. ડા. માં નોંધ આધારે") ||
                                          row.vehicle_reason ===
                                          "Noted on the basis of St. Dr."
                                          ? "green"
                                          : row.muddamaal_type === "વાહન" ||
                                            (row.muddamaal_type === "Vehicle" &&
                                              row.vehicle_reason === "બિનવારસી") ||
                                            row.vehicle_reason === "Unclaimed"
                                            ? "blue"
                                            : row.muddamaal_type === "વાહન" ||
                                              (row.muddamaal_type === "Vehicle" &&
                                                row.vehicle_reason === "અન્ય") ||
                                              row.vehicle_reason === "Others"
                                              ? "orange"
                                              : row.muddamaal_type === "વાહન" ||
                                                (row.muddamaal_type === "Vehicle" &&
                                                  row.vehicle_reason ===
                                                  "કોગ્નિઝેબલ ગુનો કરવા માટે વપરાતું વાહન") ||
                                                row.vehicle_reason ===
                                                "Vehicle used for committing Cognizable Offence"
                                                ? "brown"
                                                : row.muddamaal_type === "વાહન" ||
                                                  (row.muddamaal_type === "Vehicle" &&
                                                    row.vehicle_reason ===
                                                    "નશામાં ડ્રાઇવિંગ") ||
                                                  row.vehicle_reason === "Druken Driving"
                                                  ? "deeppink"
                                                  : row.muddamaal_type === "વાહન" ||
                                                    (row.muddamaal_type === "Vehicle" &&
                                                      row.vehicle_reason ===
                                                      "અન્ય વિશેષ અને સ્થાનિક કાયદાઓ હેઠળ આચરવામાં આવેલ કોઈપણ અન્ય ગુનો") ||
                                                    row.vehicle_reason ===
                                                    "Any other offence committed under other Special &  Local Laws"
                                                    ? "lightseagreen"
                                                    : ""
                                    } `}
                                >
                                  {row.muddamaal_type === "વાહન" ||
                                    row.muddamaal_type === "Vehicle" ? (
                                    <span>
                                      <span
                                        style={{
                                          color: "#003005",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: generateHighlightedText(
                                            row.muddamaal_type,
                                            searchText
                                          ),
                                        }}
                                      />
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: `(${generateHighlightedText(
                                            row.vehicle_reason,
                                            searchText
                                          )})`,
                                        }}
                                      />
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        color: "#003005",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          row.muddamaal_type || "NA",
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}
                                </td> */}
                                {/* <td
                                  className={`clm5 ${
                                    row.muddamaal_type === "અન્ય" ||
                                    row.muddamaal_type === "Others" 
                                      ? "bg-color-1"
                                      : row.muddamaal_type ===
                                          "ડ્રગ્સ & નાર્કોટિક્સ" ||
                                        row.muddamaal_type ===
                                          "Drugs & Narcotics"
                                      ? "bg-color-2"
                                      : row.muddamaal_type ===
                                          "સાંસ્કૃતિક મિલકત" ||
                                        row.muddamaal_type ===
                                          "Cultural Heritage"
                                      ? "bg-color-3"
                                      : row.muddamaal_type === "ચલણી નાણું" ||
                                        row.muddamaal_type ===
                                          "Counterfeit Currency"
                                      ? "bg-color-4"
                                      : row.muddamaal_type === "અગ્નિ હથિયાર" ||
                                        row.muddamaal_type === "Firearms"
                                      ? "bg-color-5"
                                      : row.muddamaal_type === "અન્ય હથિયાર" ||
                                        row.muddamaal_type === "Other Weapons"
                                      ? "bg-color-6"
                                      : row.muddamaal_type === "પ્રોહિબીશન" ||
                                        row.muddamaal_type === "Prohibition"
                                      ? "bg-color-7"
                                      : row.muddamaal_type === "સોનું" ||
                                        row.muddamaal_type === "Gold"
                                      ? "bg-color-8"
                                      : row.muddamaal_type === "ઘરેણાં" ||
                                        row.muddamaal_type === "Jewellery"
                                      ? "bg-color-9"
                                      : row.muddamaal_type ===
                                          "બિનવારસી મુદ્દામાલ" ||
                                        row.muddamaal_type ===
                                          "Unclaimed Property"
                                      ? "bg-color-10"
                                      : row.muddamaal_type ===
                                          "બનાવટી ચલણી નાણું" ||
                                        row.muddamaal_type ===
                                          "Counterfeit Currency"
                                      ? "bg-color-11"
                                      : row.muddamaal_type.trim() ===
                                          "મોબાઈલ અને ઇલેક્ટ્રોનિક ઇકવિપમેનટ" ||
                                        row.muddamaal_type.trim() ===
                                          "Mobile and Electronic Equipments"
                                      ? "bg-color-12"
                                      : row.muddamaal_type === "IMFL"
                                      ? "bg-color-6"
                                      : row.muddamaal_type ===
                                        "Gold and Jewellery"
                                      ? "bg-color-3"
                                      : row.muddamaal_type === "Illicit liquor"
                                      ? "bg-color-4"
                                      : row.muddamaal_type === "Handia"
                                      ? "bg-color-5"
                                      : row.muddamaal_type ===
                                        "Counterfeit Goods"
                                      ? "bg-color-10"
                                      : row.muddamaal_type === "વાહન" ||
                                        row.muddamaal_type === "Vehicle"
                                      ? "bg-color-133"
                                      : ""
                                  }`}
                                  
                                >
                                
                                  {row.muddamaal_type === "વાહન" ||
                                  row.muddamaal_type === "Vehicle" ? (
                                    <span>
                                      <span
                                        className="truncated"
                                        title={row.muddamaal_type}
                                        style={{
                                          color: "#003005",
                                          // border:"2px solid green",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: generateHighlightedText(
                                            truncateText(row.muddamaal_type, 2),
                                            searchText
                                          ),
                                        }}
                                      />
                                      <span
                                        className="truncated"
                                        title={row.vehicle_reason}
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: `(${generateHighlightedText(
                                            truncateText(row.vehicle_reason, 2),
                                            searchText
                                          )})`,
                                        }}
                                      />
                                    </span>
                                  ) : (
                                    <span
                                      className="truncated"
                                      title={row.muddamaal_type || "NA"}
                                      style={{
                                        // border: "2px solid red",
                                        color: "#003005",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          truncateText(
                                            row.muddamaal_type || "NA",
                                            2
                                          ),
                                          searchText
                                        ),
                                      }}
                                    />
                                  )}
                                </td> */}
                                <td
                                  className={`clm5 ${
                                    row.muddamaal_type === "અન્ય" ||
                                    row.muddamaal_type === "Others" ||
                                    row.muddamaal_type === "इतर" ||
                                    row.muddamaal_type === "भाग-5" ||
                                    row.muddamaal_type === "अन्य"
                                      ? "custom-bg-color-1"
                                      : row.muddamaal_type ===
                                            "ડ્રગ્સ & નાર્કોટિક્સ" ||
                                          row.muddamaal_type ===
                                            "Drugs & Narcotics" ||
                                          row.muddamaal_type ===
                                            "औषधे आणि अंमली पदार्थ" ||
                                          row.muddamaal_type === "भाग-6" ||
                                          row.muddamaal_type ===
                                            "ड्रग्स और नारकोटिक्स"
                                        ? "custom-bg-color-2"
                                        : row.muddamaal_type ===
                                              "સાંસ્કૃતિક મિલકત" ||
                                            row.muddamaal_type ===
                                              "Cultural Heritage" ||
                                            row.muddamaal_type ===
                                              "सांस्कृतिक वारसा" ||
                                            row.muddamaal_type ===
                                              "प्रोहिबिशन (दारूबंदी)" ||
                                            row.muddamaal_type ===
                                              "सांस्कृतिक विरासत"
                                          ? "custom-bg-color-3"
                                          : row.muddamaal_type ===
                                                "ચલણી નાણું" ||
                                              row.muddamaal_type ===
                                                "Counterfeit Currency" ||
                                              row.muddamaal_type ===
                                                "बनावट चलन" ||
                                              row.muddamaal_type ===
                                                "नकली मुद्रा"
                                            ? "custom-bg-color-4"
                                            : row.muddamaal_type ===
                                                  "અગ્નિ હથિયાર" ||
                                                row.muddamaal_type ===
                                                  "Firearms" ||
                                                row.muddamaal_type ===
                                                  "आकस्मिक मृत्यू (अ.मु.)" ||
                                                row.muddamaal_type ===
                                                  "बंदुक" ||
                                                row.muddamaal_type ===
                                                  "आग्नेयास्त्रों"
                                              ? "custom-bg-color-5"
                                              : row.muddamaal_type ===
                                                    "અન્ય હથિયાર" ||
                                                  row.muddamaal_type ===
                                                    "Other Weapons" ||
                                                  row.muddamaal_type ===
                                                    "इतर शस्त्रे" ||
                                                  row.muddamaal_type ===
                                                    "इतर शस्त्रे" ||
                                                  row.muddamaal_type ===
                                                    "बेवारस"
                                                ? "custom-bg-color-6"
                                                : row.muddamaal_type?.trim() ===
                                                      "મોબાઈલ અને ઇલેક્ટ્રોનિક ઇકવિપમેનટ" ||
                                                    row.muddamaal_type?.trim() ===
                                                      "Mobile and Electronic Equipments" ||
                                                    row.muddamaal_type?.trim() ===
                                                      "Mobile and Electronic Equipments" ||
                                                    row.muddamaal_type?.trim() ===
                                                      "मोबाइल आणि इलेक्ट्रॉनिक उपकरणे"
                                                  ? "custom-bg-color-12"
                                                  : row.muddamaal_type ===
                                                        "IMFL" ||
                                                      row.muddamaal_type ===
                                                        "आय एम एफ एल" ||
                                                      row.muddamaal_type ===
                                                        "आईएमएफएल"
                                                    ? "custom-bg-color-6"
                                                    : row.muddamaal_type ===
                                                          "Gold and Jewellery" ||
                                                        row.muddamaal_type ===
                                                          "Gold and Jewellery" ||
                                                        row.muddamaal_type ===
                                                          "सोने आणि दागिने"
                                                      ? "custom-bg-color-3"
                                                      : row.muddamaal_type ===
                                                            "Illicit liquor" ||
                                                          row.muddamaal_type ===
                                                            "Illicit liquor" ||
                                                          row.muddamaal_type ===
                                                            "अवैध दारू"
                                                        ? "custom-bg-color-4"
                                                        : row.muddamaal_type ===
                                                              "Handia" ||
                                                            row.muddamaal_type ===
                                                              "हंडिया" ||
                                                            row.muddamaal_type ===
                                                              "हंडिया"
                                                          ? "custom-bg-color-5"
                                                          : row.muddamaal_type ===
                                                                "Counterfeit Goods" ||
                                                              row.muddamaal_type ===
                                                                "बनावट वस्तू" ||
                                                              row.muddamaal_type ===
                                                                "नकली माल"
                                                            ? "custom-bg-color-10"
                                                            : row.muddamaal_type ===
                                                                  "વાહન" ||
                                                                row.muddamaal_type ===
                                                                  "Vehicle" ||
                                                                row.muddamaal_type ===
                                                                  "Vehicle" ||
                                                                row.muddamaal_type ===
                                                                  "वाहन"
                                                              ? "custom-bg-color-13"
                                                              : ""
                                  }`}
                                >
                                  {row.muddamaal_type === "વાહન" ||
                                  row.muddamaal_type === "Vehicle" ? (
                                    <div className="custom-tooltip-container">
                                      <span
                                        className="custom-truncated"
                                        style={{
                                          color: "#003005",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: generateHighlightedText(
                                            truncateText(row.muddamaal_type, 2),
                                            searchText,
                                          ),
                                        }}
                                      />
                                      <span
                                        className="custom-truncated"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: `(${generateHighlightedText(
                                            truncateText(row.vehicle_reason, 2),
                                            searchText,
                                          )})`,
                                        }}
                                        // style={{
                                        //   display: "flex",
                                        //   alignItems: "center",
                                        //   justifyContent: "center",
                                        // }}
                                      />
                                      <span className="custom-tooltiptext">
                                        {row.vehicle_reason}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="custom-tooltip-container">
                                      <span
                                        className="custom-truncated"
                                        style={{
                                          color: "#003005",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: generateHighlightedText(
                                            truncateText(
                                              row.muddamaal_type || "NA",
                                              2,
                                            ),
                                            searchText,
                                          ),
                                        }}
                                      />
                                      <span className="custom-tooltiptext">
                                        {row.muddamaal_type || "NA"}
                                      </span>
                                    </div>
                                  )}
                                </td>

                                <td className="clm6 new_datalist-quantity-column">
                                  <span
                                    className="new_datalist-quantity-value"
                                    dangerouslySetInnerHTML={{
                                      __html: generateHighlightedText(
                                        row.quantity !== null &&
                                          row.quantity !== undefined
                                          ? row.quantity.toString()
                                          : "NA",
                                        searchText,
                                      ),
                                    }}
                                  />
                                  <span className="new_datalist-unit-value">
                                    {row.unit || "NA"}
                                  </span>
                                </td>

                                {userState === "Gujarat" && (
                                  <td
                                    className="clm7 new_datalist-price-column"
                                    dangerouslySetInnerHTML={{
                                      __html: `₹ ${generateHighlightedText(
                                        row.price || "NA",
                                        searchText,
                                      )}`,
                                    }}
                                  ></td>
                                )}

                                <td className="clm8">
                                  <span
                                    className="status-text"
                                    onClick={() => handleButtonClick(row.id)}
                                    onKeyDown={(event) => {
                                      if (
                                        event.key === "Enter" ||
                                        event.key === " "
                                      ) {
                                        event.preventDefault();
                                        handleButtonClick(row.id);
                                      }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    style={{ cursor: "pointer" }}
                                    dangerouslySetInnerHTML={{
                                      __html: generateHighlightedText(
                                        row.status_of_muddamaal || "NA",
                                        searchText,
                                      ),
                                    }}
                                  />
                                  <div className="custody-bottom">
                                    <button
                                      className="custody-logs"
                                      onClick={() => handleButtonClick(row.id)}
                                    >
                                      Custody Log
                                    </button>
                                  </div>
                                  {isPopupOpen && <CustodyLog />}
                                </td>

                                <td
                                  className="clm9 new_datalist-column--detail"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      formatDates(row.created_at || "NA"),
                                      searchText,
                                    ),
                                  }}
                                />

                                <td
                                  className="clm0 new_datalist-column--detail"
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row.section_of_law ? (
                                    <Tooltip
                                      title={(() => {
                                        try {
                                          const parsedLaw = JSON.parse(
                                            row.section_of_law,
                                          );
                                          const lawEntries =
                                            Object.entries(parsedLaw);

                                          return (
                                            <table className="tooltip-table">
                                              <thead>
                                                <tr>
                                                  <th className="acts-data">
                                                    Acts
                                                  </th>
                                                  <th className="laws-data">
                                                    Section of Laws
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {lawEntries.map(
                                                  (
                                                    [lawKey, lawValue],
                                                    index,
                                                  ) => (
                                                    <tr key={index}>
                                                      <td>
                                                        {lawKey ===
                                                        "Others Acts"
                                                          ? `Others Acts (${row.specify_act})`
                                                          : lawKey || "NA"}
                                                      </td>
                                                      <td>
                                                        {lawValue || "NA"}
                                                      </td>
                                                    </tr>
                                                  ),
                                                )}
                                              </tbody>
                                            </table>
                                          );
                                        } catch (error) {
                                          console.error(
                                            "Error parsing section_of_law:",
                                            error,
                                          );
                                          return "NA";
                                        }
                                      })()}
                                      arrow
                                      //
                                      PopperProps={{
                                        sx: {
                                          "& .MuiTooltip-tooltip": {
                                            backgroundColor: "transparent", // Your custom background
                                            color: "#000", // Text color
                                            border: "1px solid blue", // Border for the tooltip
                                            padding: "0px",
                                            marginLeft: "10px",
                                            marginTop: "-5px",
                                          },
                                          "& .MuiTooltip-arrow": {
                                            color: "#14195d", // This changes the color of the arrow (same as the border)
                                            "&:before": {
                                              // border: '1px solid ', // Border for the arrow itself
                                              // marginLeft:'40%'
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      <span>
                                        view
                                        <BsInfoCircle className="person-icon" />
                                      </span>
                                    </Tooltip>
                                  ) : (
                                    "NA"
                                  )}
                                </td>

                                {/* <td className="clm10">
                                  <div className="tooltip-container">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          truncateTextByCharLimit(
                                            row.description || "NA"
                                          ),
                                          searchText
                                        ),
                                      }}
                                    />
                                    <span className="tooltiptext">
                                      {row.description || "NA"}
                                    </span>
                                  </div>
                                </td> */}
                                <td className="clm10 new_datalist-column--detail">
                                  <div className="tooltip-container">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          truncateTextByWordLimit(
                                            row.description || "NA",
                                          ), // Now truncating by words
                                          searchText,
                                        ),
                                      }}
                                    />
                                    <span className="tooltiptext">
                                      {row.description || "NA"}{" "}
                                      {/* Full description in the tooltip */}
                                    </span>
                                  </div>
                                </td>

                                <td className="new_datalist-column--detail">
                                  {formatDate(row.chart_sheet_date || "NA")}
                                </td>

                                <td className="new_datalist-column--detail">
                                  {formatDate(row.next_court_date || "NA")}
                                </td>

                                {/* <span className="tooltiptext">{row.description || "NA"}</span> */}

                                {/* <td className="clms1">
                                  <div className="remarkbar1">
                                    <div className="inputs-container">
                                      <Tooltip
                                        title={row.pendency_reason}
                                        arrow
                                      >
                                        <input
                                          type="text"
                                          value={
                                            remark[row.id] ??
                                            row.pendency_reason ??
                                            ""
                                          }
                                          style={{
                                            border:
                                              editingId === row.id
                                                ? "2px solid #4189db"
                                                : "none",
                                            // Check if the input is in editing mode
                                            transition:
                                              "border-color 0.3s ease",
                                            outline:
                                              editingId === row.id
                                                ? "none"
                                                : "1px solid black",
                                          }}
                                          onChange={(e) =>
                                            handleRemarkChange(e, row.id)
                                          }
                                          readOnly={editingId !== row.id} // Make the input read-only when not editing
                                        />
                                      </Tooltip>

                                      <div className="icon-set-remark">
                                        {editingId === row.id ? (
                                          <img
                                            src="/check-circle.svg"
                                            alt="Save"
                                            className="icon-remark"
                                            onClick={() => {
                                              handleRemarkSet(row.id); // Save the remark
                                              setEditingId(null); // Reset editing ID after saving
                                            }}
                                          />
                                        ) : (
                                          <PiPencilSimpleLineLight
                                            className="icon-remark"
                                            onClick={() => setEditingId(row.id)} // Enter editing mode
                                          />
                                        )}
                                      </div>
                                    </div>

                                    <div className="remark-set-success"></div>
                                  </div>
                                </td> */}
                                <td
                                  className="clms1 new_datalist-remark-cell new_datalist-column--detail"
                                  style={{ padding: "8px" }}
                                >
                                  <div
                                    className="remarkbar1"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        row.pendency_reason ||
                                        "No reason available"
                                      }
                                      arrow
                                    >
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        value={
                                          remark[row.id] ??
                                          row.pendency_reason ??
                                          ""
                                        }
                                        onChange={(e) =>
                                          handleRemarkChange(e, row.id)
                                        }
                                        InputProps={{
                                          readOnly: editingId !== row.id,
                                          style: {
                                            border:
                                              editingId === row.id
                                                ? "2px solid #4189db"
                                                : "1px solid #d3d3d3",
                                            transition:
                                              "border-color 0.3s ease",
                                          },
                                        }}
                                        fullWidth
                                      />
                                    </Tooltip>

                                    <div
                                      className="icon-set-remark"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {editingId === row.id ? (
                                        <IconButton
                                          color="primary"
                                          onClick={() => {
                                            handleRemarkSet(row.id); // Save the remark
                                            setEditingId(null); // Reset editing ID after saving
                                          }}
                                          size="small" // Matches input height better
                                          aria-label="Save remark"
                                        >
                                          <CheckCircleIcon />
                                        </IconButton>
                                      ) : (
                                        <IconButton
                                          color="default"
                                          onClick={() => setEditingId(row.id)} // Enter editing mode
                                          size="small" // Matches input height better
                                          aria-label="Edit remark"
                                        >
                                          <EditIcon />
                                        </IconButton>
                                      )}
                                    </div>
                                  </div>
                                  <div className="remark-set-success"></div>
                                </td>
                                <td className="clm1 new_datalist-attachment-cell">
                                  <Tooltip title="Attachments" arrow>
                                    <button
                                      aria-label="Open attachments"
                                      className="inquiry-file-btn"
                                      onClick={() =>
                                        handleAttachmentIconClick(row.id)
                                      }
                                      type="button"
                                    >
                                      <MdAttachFile className="inquiry-file-icon" />
                                    </button>
                                  </Tooltip>
                                </td>
                                <td className="clm11 new_datalist-action-cell">
                                  <div className="action-button">
                                    <button
                                      aria-label="Print case property record"
                                      className="popup-button print-datalist"
                                      onClick={() => handleView(row.id)}
                                      type="button"
                                    >
                                      <IoPrintOutline className="view-btn" />
                                      <span className="popup-index">Print</span>
                                    </button>
                                    {can("crime_data", "update") && (
                                      <button
                                        aria-label="Edit case property record"
                                        className="popup-button edit-datalist"
                                        onClick={() => handleEditClick(row)}
                                        type="button"
                                      >
                                        <FiEdit className="edit-btn" />
                                        <span className="popup-index">
                                          Edit
                                        </span>
                                      </button>
                                    )}
                                    {/* <div
                                      className="popup-button delete-datalist"
                                      onClick={() => handleDeleteClick(row.id)}
                                    >
                                     
                                      <MdDeleteOutline className="delete-btn" />
                                      <div className="popup-index">Delete</div>
                                    </div> */}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <p>No data available.</p>
              )}
            </>
          ))}
        <Pagination
          className="pagination--compact new_datalist-pagination"
          showPerPage={showPerPage}
          total={filteredData.length}
          onPaginationChange={onPaginationChange}
          handleShowPerPageChange={handleShowPerPageChange}
          translate={translatedText}
          resetKey={`${searchText}|${sortOrder}|${selectedOption}|${
            selectedStartDate?.toISOString?.() || ""
          }|${selectedEndDate?.toISOString?.() || ""}|${selectedDistrictId}|${
            selectedSubDivisionId
          }|${selectedStationId}`}
        />
      </div>
      {/* {showActPopup && (
        <div className="act-view-popup">
          <div className="act-view-popup-content">
            <div className="act-view-popup-heading">
              <div className="act-view-popup-heading-content">
                All Act
              </div>
              <div className="act-view-popup-heading-content" onClick={closeActButton}>
                close
              </div>
            </div>
            <div className="act-view-popup-header-separator"></div>
            <div className="act-view-popup-body">
              {data.map((row) => (
                <div className="act-view-popup-body-content" key={row.id}>
                  {row.act}
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}
      {showActPopup && selectedActRow && (
        <div className="act-view-popup">
          <div className="act-view-popup-content">
            <div className="act-view-popup-heading">
              <div className="act-view-popup-heading-content">All Act</div>
              <div
                className="act-view-popup-heading-content close-icon"
                onClick={closeActButton}
              >
                <IoMdClose />
              </div>
            </div>
            <div className="act-view-popup-header-separator"></div>
            <div className="act-view-popup-body">
              {selectedActRow.act ? (
                <div className="act-view-popup-body-content">
                  {selectedActRow.act}
                </div>
              ) : (
                <div className="act-view-popup-body-content">
                  No data available
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showSpecifyActPopup && selectedSpecifyActRow && (
        <div className="act-view-popup">
          <div className="act-view-popup-content">
            <div className="act-view-popup-heading">
              <div className="act-view-popup-heading-content">
                All Specify Act
              </div>
              <div
                className="act-view-popup-heading-content close-icon"
                onClick={closeSpecifyActButton}
              >
                <IoMdClose />
              </div>
            </div>
            <div className="act-view-popup-header-separator"></div>
            <div className="act-view-popup-body">
              {selectedSpecifyActRow.specify_act ? (
                <div className="act-view-popup-body-content">
                  {selectedSpecifyActRow.specify_act}
                </div>
              ) : (
                <div className="act-view-popup-body-content">
                  No data available
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showSectionOfLawPopup && selectedSectionOfLawRow && (
        <div className="act-view-popup">
          <div className="act-view-popup-content">
            <div className="act-view-popup-heading">
              <div className="act-view-popup-heading-content">
                {translatedText("All_Section_Of_Law")}
              </div>
              <div
                className="act-view-popup-heading-content close-icon"
                onClick={closeSectionOfLawButton}
              >
                <IoMdClose />
              </div>
            </div>
            <div className="act-view-popup-header-separator"></div>
            <div className="act-view-popup-body">
              <div className="act-view-popup-body-content">
                {selectedSectionOfLawRow.section_of_law}
              </div>
            </div>
          </div>
        </div>
      )}
      {showPopup && (
        <div className="data-view-popup">
          <DataView
            data={selectedData}
            qrCodeUrl={`${API_URL}/api/data/${selectedData.id}/qr`}
            onClose={handleClosePopup}
          />
        </div>
      )}

      {showDeleteAlert && (
        <div className="popup2">
          <div className="popup-content2">
            <p>{translatedText("delete_message")}</p>
            <div className="button-group2">
              <button className="btn1" onClick={handleConfirmDelete}>
                Yes
              </button>
              <button
                className="btn2"
                onClick={() => setShowDeleteAlert(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {showDeleteSuccessAlert && (
        <div className="popup3">
          <div className="popup-content3">
            <p>{translatedText("confirm_delete_message")}</p>
            <button className="btn3" onClick={handleCloseDeleteSuccessAlert}>
              Ok
            </button>
          </div>
        </div>
      )}
      {showQRGeneratedSuccessAlert && (
        <div className="popup">
          <div className="popup-content">
            <p>QR generated successfully!</p>
            <button
              className="btn4"
              onClick={() => setShowQRGeneratedSuccessAlert(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
      {showEditForm && selectedData && (
        <div
          className="insert-data-popup new_data-form-popup new_data-form-popup--edit"
          ref={insertRef}
        >
          <div className="popup-content data-box new_data-form-surface">
            <div className="heading-content new_data-form-heading">
              <div className="heading">Edit Data</div>
              <div className="close-icon" onClick={handleEditClose}>
                <IoMdClose />
              </div>
            </div>
            <div className="insert-popup edit-pop new_data-form-scroll">
              <div className="new_data-form-body">
                <div
                  style={{ width: "100%" }}
                  className="insert-form new_data-form-card"
                >
                  <div className="insert-form-content new_data-form-content">
                    <form
                      id="records-edit-form"
                      onSubmit={handleEditSubmit}
                      className="submit new_data-form"
                    >
                      <div className="first-input-form-group new_data-form-grid">
                        {/* <div className="gunanumber form-group">
                      <label htmlFor="gunaNumberInput">
                        <span className="text-danger">*</span>
                        {translatedText("guna_number")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="gunaNumberInput"
                          value={selectedData.guna_number}
                          className="form-control"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              guna_number: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div> */}

                        <EntryTypeFields
                          entryTypes={entryTypes}
                          selectedEntryType={selectedData.entry_type}
                          selectedLanguage={selectedLanguage}
                          value={selectedData}
                          errors={editValidationErrors}
                          translatedText={translatedText}
                          onEntryTypeChange={handleEntryTypeChange}
                          onFieldChange={handleEntryTypeFieldChange}
                          idPrefix={`records-edit-${selectedData.id || "case"}`}
                        />

                        <div className=" form-group">
                          <label htmlFor="dateOfSeizureInput">
                            <span className="text-danger">*</span>
                            {translatedText("date_of_seizure")}
                          </label>
                          <div className="date-picker-container">
                            <div className="input-group">
                              <DatePicker
                                selected={
                                  new Date(selectedData.date_of_seizure)
                                }
                                className="form-control date-picker-input"
                                onChange={(date) =>
                                  setSelectedData({
                                    ...selectedData,
                                    date_of_seizure: date.toISOString(),
                                  })
                                }
                                dateFormat="dd/MM/yyyy" // Format as needed
                                id="dateOfSeizureInput"
                                showPopperArrow={false} // Optional: To hide the arrow on the date picker
                              />
                            </div>
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                // onClick={() => handleDateIconClick(index)}
                              >
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="exhibitnumber form-group">
                          <label htmlFor="exhibitNumberInput">
                            {" "}
                            <span className="text-danger">*</span>
                            {translatedText("exhibit_number")}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              id="exhibitNumberInput"
                              className="form-control"
                              value={selectedData.exhibit_number}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  exhibit_number: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                        {activeCasePropertyTypeOptions.length > 0 && (
                          <div className="form-group">
                            <label htmlFor="muddamaalTypeInput">
                              <span className="text-danger">*</span>
                              {translatedText("muddamaal_type")}
                            </label>
                            <div className="input-group">
                              <select
                                type="text"
                                id="muddamaalTypeInput"
                                className="form-control"
                                value={selectedData.muddamaal_type}
                                onChange={(e) =>
                                  setSelectedData({
                                    ...selectedData,
                                    muddamaal_type: e.target.value,
                                    vehicle_reason: isVehicleCasePropertyType(
                                      e.target.value,
                                      masterCasePropertyTypeOptions,
                                    )
                                      ? matchOptionValue(
                                          masterVehicleReasonOptions,
                                          selectedData.vehicle_reason,
                                        ) ||
                                        masterVehicleReasonOptions[0]?.value ||
                                        ""
                                      : "",
                                  })
                                }
                              >
                                {(activeCasePropertyTypeOptions.some(
                                  (option) =>
                                    option.value ===
                                    selectedData.muddamaal_type,
                                )
                                  ? activeCasePropertyTypeOptions
                                  : [
                                      {
                                        label: selectedData.muddamaal_type,
                                        value: selectedData.muddamaal_type,
                                      },
                                      ...activeCasePropertyTypeOptions,
                                    ].filter((option) => option?.value)
                                ).map((option, optionIndex) => (
                                  <option
                                    key={option.id || optionIndex}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {/* {userState === "Andaman and Nicobar" &&
                      selectedData.muddamaal_type ===
                        translatedText("other") && (
                        <div className="form-group">
                          <label htmlFor="other_case_property_name">
                            {translatedText("other_case_property")}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="other_case_property_name"
                              id="other_case_property_name"
                              placeholder={translatedText(
                                "enter_other_case_property"
                              )}
                              className="form-control"
                              value={
                                selectedData.other_case_property_name || ""
                              }
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  other_case_property_name: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                      )} */}

                        {(userState === "Andaman and Nicobar" ||
                          userState === "Maharashtra") &&
                          isOtherCasePropertyType(
                            selectedData.muddamaal_type,
                            masterCasePropertyTypeOptions,
                          ) && (
                            <div className="form-group">
                              <label htmlFor="other_case_property_name">
                                {translatedText("other_case_property")}
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="other_case_property_name"
                                  id="other_case_property_name"
                                  placeholder={translatedText(
                                    "enter_other_case_property",
                                  )}
                                  className="form-control"
                                  value={
                                    selectedData.other_case_property_name || ""
                                  }
                                  onChange={(e) =>
                                    setSelectedData({
                                      ...selectedData,
                                      other_case_property_name: e.target.value,
                                    })
                                  }
                                  min="0"
                                />
                              </div>
                            </div>
                          )}

                        {isVehicleCasePropertyType(
                          selectedData.muddamaal_type,
                          masterCasePropertyTypeOptions,
                        ) && (
                          <div className="form-group">
                            <label htmlFor="vehicleReasonInput">
                              <span className="text-danger">*</span>
                              {translatedText(
                                "reason_for_impounding_the_vehicle",
                              )}
                            </label>
                            <div className="input-group">
                              <select
                                type="text"
                                id="vehicleReasonInput"
                                className="form-control"
                                value={selectedData.vehicle_reason}
                                onChange={(e) =>
                                  setSelectedData({
                                    ...selectedData,
                                    vehicle_reason: e.target.value,
                                  })
                                }
                              >
                                {(masterVehicleReasonOptions.length > 0
                                  ? masterVehicleReasonOptions
                                  : selectedData.vehicle_reason
                                    ? [
                                        {
                                          label: selectedData.vehicle_reason,
                                          value: selectedData.vehicle_reason,
                                        },
                                      ]
                                    : []
                                ).map((option, optionIndex) => (
                                  <option
                                    key={option.id || optionIndex}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {/* Charge Sheet Date */}
                        <div className="form-group">
                          <label htmlFor="chargeSheetDateInput">
                            <span className="text-danger">*</span>
                            {translatedText("chart_sheet_date")}
                          </label>
                          <div className="date-picker-container">
                            <div className="input-group">
                              <DatePicker
                                selected={
                                  selectedData.chart_sheet_date
                                    ? new Date(selectedData.chart_sheet_date)
                                    : null // Show placeholder if null
                                }
                                onChange={(date) =>
                                  setSelectedData((prevData) => ({
                                    ...prevData,
                                    chart_sheet_date: date
                                      ? date.toISOString()
                                      : null,
                                  }))
                                }
                                dateFormat="dd/MM/yyyy"
                                placeholderText={translatedText(
                                  "enter_chart_sheet_date",
                                )}
                                isClearable
                                id="chargeSheetDateInput"
                                showPopperArrow={false}
                                className="form-control date-picker-input"
                              />
                            </div>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="nextCourtDateInput">
                            <span className="text-danger">*</span>
                            {translatedText("next_court_date")}
                          </label>
                          <div className="date-picker-container">
                            <div className="input-group">
                              <DatePicker
                                selected={
                                  selectedData.next_court_date
                                    ? new Date(selectedData.next_court_date)
                                    : null // Show placeholder if null
                                }
                                onChange={(date) =>
                                  setSelectedData((prevData) => ({
                                    ...prevData,
                                    next_court_date: date
                                      ? date.toISOString()
                                      : null,
                                  }))
                                }
                                dateFormat="dd/MM/yyyy"
                                placeholderText={translatedText(
                                  "enter_next_court_date",
                                )}
                                isClearable
                                id="nextCourtDateInput"
                                showPopperArrow={false}
                                className="form-control date-picker-input"
                              />
                            </div>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="unit">{translatedText("unit")}</label>
                          <br />
                          <div className="input-group">
                            <select
                              id="unit"
                              name="unit"
                              className="form-control"
                              value={selectedUnit}
                              onChange={handleUnitChange}
                            >
                              <option value="">
                                {translatedText("select_unit")}
                              </option>
                              {(masterUnitOptions.length > 0
                                ? masterUnitOptions
                                : selectedUnit
                                  ? [
                                      {
                                        label: selectedUnit,
                                        value: selectedUnit,
                                      },
                                    ]
                                  : []
                              ).map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <MdExpandMore />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="quantity form-group">
                          <label htmlFor="quantityInput">
                            {translatedText("quantity")}
                          </label>
                          <div className="input-group">
                            <input
                              type="number"
                              id="quantityInput"
                              className="form-control"
                              value={selectedData.quantity}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  quantity: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="price form-group">
                          <label htmlFor="priceInput">
                            {translatedText("price")}
                          </label>
                          <div className="input-group">
                            <input
                              type="price"
                              id="priceInput"
                              className="form-control"
                              value={selectedData.price}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  price: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="description-group form-group">
                          <label htmlFor="descriptionInput">
                            {translatedText("description")}
                          </label>
                          <div className="input-group">
                            <textarea
                              type="textarea"
                              id="descriptionInput"
                              className="form-control desc-txt"
                              value={selectedData.description}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  description: e.target.value,
                                })
                              }
                            />
                            <small className="word-count">
                              {countWords(selectedData.description)} words
                            </small>
                          </div>
                        </div>
                      </div>

                      {/* <div className="middle-input-form-group">
                    <div className="acts-group">
                      <div className="form-group">
                        <label htmlFor="selectedOptions">Acts</label>
                        <Multiselect
                          options={options}
                          selectedValues={selectedOptions}
                          onSelect={handleSelect}
                          onRemove={handleRemove}
                          displayValue="name"
                          style={{
                            chips: {
                              background: "#007bff",
                              color: "#fff",
                              fontSize: "14px",
                            },
                            searchBox: { border: "1px solid #D9E1FF" },
                            optionContainer: {
                              border: "1px solid #007bff",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          }}
                          placeholder="Select options"
                          closeIcon="cancel"
                          avoidHighlightFirstOption={true}
                          showCheckbox={true}
                          hidePlaceholder={false}
                          closeOnSelect={false}
                        />
                      </div>
                    </div>
                    {selectedOptions.some(
                      (option) => option.name === "Others Acts"
                    ) && (
                        <div className="form-group">
                          <label htmlFor="specifyAct">Specify Act</label>
                          <input
                            type="text"
                            name="specifyAct"
                            id="specifyAct"
                            className="form-control"
                            value={specifyAct}
                            onChange={(e) => setSpecifyAct(e.target.value)}
                            placeholder="Specify act"
                          />
                        </div>
                      )}
                    <div className="sub-middle-input-form-group">
                      {selectedOptions.map((option) => (
                        <div key={option.id} className="form-group">
                          <label htmlFor={option.name}>{option.name}</label>
                          <input
                            type="text"
                            name={option.name}
                            id={option.name}
                            className="form-control"
                            value={sectionOfLaws[option.name] || ""}
                            onChange={(e) =>
                              handleSectionOfLawChange(e, option.name)
                            }
                            placeholder={`Section of law for ${option.name}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div> */}

                      <div className="middle-input-form-group new_data-form-section">
                        <div className="acts-group">
                          <div className="form-group">
                            <label htmlFor="selectedOptions">
                              {translatedText("act")}
                            </label>
                            <Multiselect
                              // options={options}
                              options={filteredOptions}
                              selectedValues={selectedOptions}
                              onSelect={handleSelect}
                              onRemove={handleRemove}
                              displayValue="name"
                              style={{
                                chips: {
                                  background: "#007bff",
                                  color: "#fff",
                                  fontSize: "14px",
                                },
                                searchBox: { border: "1px solid #D9E1FF" },
                                optionContainer: {
                                  border: "1px solid #007bff",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                },
                              }}
                              placeholder={translatedText("select_option")}
                              closeIcon="cancel"
                              avoidHighlightFirstOption={true}
                              showCheckbox={true}
                              hidePlaceholder={false}
                              closeOnSelect={false}
                            />
                          </div>
                        </div>

                        <div className="sub-middle-input-form-group new_data-form-subgrid">
                          {selectedOptions.map(
                            (option) =>
                              !isOtherActOption(option) && (
                                <div key={option.id} className="form-group">
                                  <label htmlFor={option.name}>
                                    {option.name}
                                  </label>
                                  <input
                                    type="text"
                                    name={option.name}
                                    id={option.name}
                                    className="form-control"
                                    value={getSectionOfLawValue(option.name)}
                                    onChange={(e) =>
                                      handleSectionOfLawChange(e, option.name)
                                    }
                                    placeholder={`Section of law for ${option.name}`}
                                  />
                                </div>
                              ),
                          )}

                          {selectedOptions.some((option) =>
                            isOtherActOption(option),
                          ) && (
                            <div className="other-acts-group new_data-form-subgrid">
                              <div className="form-group">
                                <label htmlFor="specifyAct">Specify Act</label>
                                <input
                                  type="text"
                                  name="specifyAct"
                                  id="specifyAct"
                                  className="form-control"
                                  value={specifyAct}
                                  onChange={(e) =>
                                    setSpecifyAct(e.target.value)
                                  }
                                  placeholder="Specify act"
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor={otherActOptionName}>
                                  {otherActOptionName}
                                </label>
                                <input
                                  type="text"
                                  name={otherActOptionName}
                                  id={otherActOptionName}
                                  className="form-control"
                                  value={getSectionOfLawValue(
                                    otherActOptionName,
                                    {
                                      isOther: true,
                                    },
                                  )}
                                  onChange={(e) =>
                                    handleSectionOfLawChange(
                                      e,
                                      otherActOptionName,
                                    )
                                  }
                                  placeholder={`Section of law for ${otherActOptionName}`}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="last-button new_data-form-footer">
              <div className="last-group new_data-form-actions">
                <button
                  type="button"
                  className="case-property-button new_data-status-trigger"
                  onClick={() => {
                    setShowCasePropertyPopup(true);
                    setShowEditForm(false);
                  }}
                >
                  Update Status of Case Property
                </button>
                <button
                  type="button"
                  className="btn close-button"
                  onClick={() => setShowEditForm(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  form="records-edit-form"
                  className="btn save-button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCasePropertyPopup && selectedData && (
        <div className="update-input-form-groups new_data-status-popup">
          <div className="update-input-group-contants new_data-status-surface">
            <div className="update-popup-heading">
              <div className="update-popup-heading-content">
                Update Case Property
              </div>
              <div
                className="update-popup-heading-content close-icons"
                onClick={closeUpdateButton}
              >
                <IoMdClose className="update-icon" />
              </div>
            </div>
            <div className="update-popup-header-separator"></div>
            <div className="update-popup-body new_data-status-body">
              <form>
                <div className="form-group">
                  <label htmlFor="statusOfMuddamaalInput">
                    {translatedText("status_of_muddamaal")}
                  </label>
                  <div className="input-group">
                    <select
                      type="text"
                      id="statusOfMuddamaalInput"
                      className="form-control"
                      value={selectedData.status_of_muddamaal}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          status_of_muddamaal: e.target.value,
                        })
                      }
                    >
                      {(masterStatusOptions.length > 0
                        ? masterStatusOptions
                        : selectedData.status_of_muddamaal
                          ? [
                              {
                                label: selectedData.status_of_muddamaal,
                                value: selectedData.status_of_muddamaal,
                              },
                            ]
                          : []
                      ).map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {translatedText("destroyed_disposed") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="disposalOnCourt">
                        {translatedText("disposal_on_court_order")}
                      </label>
                      <br />
                      <div className="input-group">
                        <select
                          id="disposalOnCourt"
                          value={selectedCourtOrderOption}
                          onChange={handleDropdownCourtOrderChange}
                          className="form-control"
                        >
                          <option value="Disposed">Disposed</option>
                          <option value="Auction">Auction</option>
                        </select>
                      </div>
                    </div>

                    {selectedCourtOrderOption === "Disposed" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="executiveOrder">
                            {translatedText("order_no_for_deputed")}
                          </label>

                          <input
                            type="number"
                            name="executiveOrder"
                            id="executiveOrder"
                            className="form-control"
                            value={sectionExecutiveOrderNo}
                            onChange={(e) =>
                              setSectionExecutiveOrderNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_order_no_deputed",
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="disposalDate">
                            {translatedText("date_of_disposal")}
                          </label>

                          <input
                            type="date"
                            name="disposalDate"
                            id="disposalDate"
                            className="form-control"
                            value={sectionDisposaldate}
                            onChange={(e) =>
                              setSectionsectionDisposaldate(e.target.value)
                            }
                          />
                        </div>
                        <div className="form-group-attachment attach-new">
                          <label htmlFor="Attachment">
                            Attachment for disposal order
                          </label>
                          <div className="input-group-attachment">
                            <button
                              type="button"
                              className="challan-button"
                              onClick={handleUploadButtonClick}
                            >
                              <FiUpload /> Upload File
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleDisposalFileInputChange}
                            />
                            {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                              <span
                                className="inquiry-file-btn"
                                onClick={handleIconClick}
                              >
                                <MdAttachFile className="inquiry-file-icon" />{" "}
                                {`${selectedFiles.length}`}
                              </span>
                            )}
                            {isPopupOpens && (
                              <div className="attach-popups">
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  {selectedFiles.length > 0 && (
                                    <div className="attach-scrroll-body">
                                      {selectedFiles.map((file, index) => (
                                        <div
                                          className="attach-popup-contant-body"
                                          key={index}
                                        >
                                          <div className="attach-file-container">
                                            <div className="attach-file-show">
                                              <div className="text-attachment">
                                                {file.name.length > 15
                                                  ? `${file.name.substring(
                                                      0,
                                                      15,
                                                    )}...`
                                                  : file.name}
                                              </div>
                                              <div className="text-attachment-file">
                                                File Size:(
                                                {(file.size / 1024).toFixed(
                                                  2,
                                                )}{" "}
                                                KB)
                                              </div>
                                            </div>
                                            <div
                                              className="file-delete-btn"
                                              onClick={() =>
                                                handleDeleteFile(index)
                                              }
                                            >
                                              <span>
                                                {" "}
                                                <MdDeleteOutline className="file-delete-icon" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {selectedCourtOrderOption === "Auction" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="auctionDate">
                            {translatedText("date_of_auction")}
                          </label>
                          <input
                            type="date"
                            name="auctionDate"
                            id="auctionDate"
                            className="form-control"
                            value={sectionAuctionDate}
                            onChange={(e) =>
                              setSectionAuctionDate(e.target.value)
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="auctionOrderNo">
                            {translatedText("auction_order_no")}
                          </label>
                          <input
                            type="number"
                            name="auctionOrderNo"
                            id="auctionOrderNo"
                            className="form-control"
                            value={sectionAuctionOrderNo}
                            onChange={(e) =>
                              setSectionAuctionOrderNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_auction_order_no",
                            )}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="awarded">
                            {translatedText("awarded_to_whom")}
                          </label>
                          <input
                            type="text"
                            name="awarded"
                            id="awarded"
                            className="form-control"
                            value={sectionAawarded}
                            onChange={(e) => setSectionAawarded(e.target.value)}
                            placeholder={translatedText(
                              "enter_awarded_recipient",
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="paymentMode">
                            {translatedText("payment_made_through")}
                          </label>
                          <div className="radio-input-option pmt-radio">
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="bankDeposit"
                                name="paymentMethod"
                                className="form-group-controls"
                                value="Bank Deposit"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="bankDeposit">
                                {translatedText("bank_deposit")}
                              </label>
                            </div>
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="cheque"
                                name="paymentMethod"
                                value="Cheque"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="cheque">
                                {translatedText("cheque")}
                              </label>
                            </div>
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="challan"
                                name="paymentMethod"
                                value="Challan"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="challan">
                                {translatedText("challan")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="auctionMemoNo">
                            {translatedText("handover_memo_no")}
                          </label>
                          <input
                            type="number"
                            name="auctionMemoNo"
                            id="auctionMemoNo"
                            className="form-control"
                            value={sectionAuctionMemoNo}
                            onChange={(e) =>
                              setSectionAuctionMemoNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_handover_memo_no",
                            )}
                          />
                        </div>
                        <div className="form-group-attachment attach-new">
                          <label htmlFor="Attachment">
                            Attachment for auction order
                          </label>
                          <div className="input-group-attachment">
                            <button
                              type="button"
                              className="challan-button"
                              onClick={handleUploadButtonClick}
                            >
                              <FiUpload /> Upload File
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleAuctionFileInputChange}
                            />
                            {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                              <span
                                className="inquiry-file-btn"
                                onClick={handleIconClick}
                              >
                                <MdAttachFile className="inquiry-file-icon" />{" "}
                                {`${selectedFiles.length}`}
                              </span>
                            )}
                            {isPopupOpens && (
                              <div className="attach-popups">
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  {selectedFiles.length > 0 && (
                                    <div className="attach-scrroll-body">
                                      {selectedFiles.map((file, index) => (
                                        <div
                                          className="attach-popup-contant-body"
                                          key={index}
                                        >
                                          <div className="attach-file-container">
                                            <div className="attach-file-show">
                                              <div className="text-attachment">
                                                {file.name.length > 15
                                                  ? `${file.name.substring(
                                                      0,
                                                      15,
                                                    )}...`
                                                  : file.name}
                                              </div>
                                              <div className="text-attachment-file">
                                                File Size:(
                                                {(file.size / 1024).toFixed(
                                                  2,
                                                )}{" "}
                                                KB)
                                              </div>
                                            </div>
                                            <div
                                              className="file-delete-btn"
                                              onClick={() =>
                                                handleDeleteFile(index)
                                              }
                                            >
                                              <span>
                                                {" "}
                                                <MdDeleteOutline className="file-delete-icon" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : null}

                {translatedText("other") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="other_status_case_property">
                        {translatedText("other_status_case_property")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="other_status_case_property"
                          id="other_status_case_property"
                          className="form-control"
                          value={sectionOtherStatus}
                          onChange={(e) =>
                            setSectionOtherStatus(e.target.value)
                          }
                          placeholder={translatedText(
                            "enter_other_status_case_property",
                          )}
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("sent_to_ps_ccs") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="sentBy">
                        {translatedText("sent_by")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="sentBy"
                          id="sentBy"
                          className="form-control"
                          value={sectionSentBy}
                          onChange={(e) => setSectionSentBy(e.target.value)}
                          placeholder={translatedText("enter_sent_by")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("Date")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("central_cold_storage") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="sentBy">
                        {translatedText("sent_by")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="sentBy"
                          id="sentBy"
                          className="form-control"
                          value={sectionSentBy}
                          onChange={(e) => setSectionSentBy(e.target.value)}
                          placeholder={translatedText("enter_sent_by")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("Date")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("release_on_court_order") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="courtOrderNo">
                        {translatedText("court_order_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="CourtOrderNo"
                          id="CourtOrderNo"
                          className="form-control"
                          value={sectionCourtOrderNo}
                          onChange={(e) =>
                            setSectionCourtOrderNo(e.target.value)
                          }
                          placeholder={translatedText("enter_court_order_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="releasedToWhom">
                        {translatedText("released_to_whom")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="ReleasedToWhom"
                          id="ReleasedToWhom"
                          className="form-control"
                          value={sectionReleased}
                          onChange={(e) => setSectionReleased(e.target.value)}
                          placeholder={translatedText("enter_releaser_name")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="releseddate">
                        {translatedText("date_of_release")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          name="Releseddate"
                          id="Releseddate"
                          className="form-control"
                          value={sectionRelesedDate}
                          onChange={(e) =>
                            setSectionRelesedDate(e.target.value)
                          }
                          placeholder={translatedText("enter_date_of_release")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="gdNo">
                        {translatedText("gd_entry_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="GdNo"
                          id="GdNo"
                          className="form-control"
                          value={sectionGdNo}
                          onChange={(e) => setSectionGdNo(e.target.value)}
                          placeholder={translatedText("enter_gd_entry_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group-attachment attach-new">
                      <label htmlFor="Attachment">
                        Attachment for release on court order
                      </label>
                      <div className="input-group-attachment">
                        <button
                          type="button"
                          className="challan-button"
                          onClick={handleUploadButtonClick}
                        >
                          <FiUpload /> Upload File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleCourtOrderFileInputChange}
                        />
                        {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                          <span
                            className="inquiry-file-btn"
                            onClick={handleIconClick}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {`${selectedFiles.length}`}
                          </span>
                        )}
                        {isPopupOpens && (
                          <div className="attach-popups">
                            <div className="attach-popup-contant">
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={handleCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>
                              {selectedFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedFiles.map((file, index) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name.length > 15
                                              ? `${file.name.substring(
                                                  0,
                                                  15,
                                                )}...`
                                              : file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:(
                                            {(file.size / 1024).toFixed(2)} KB)
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteFile(index)
                                          }
                                        >
                                          <span>
                                            {" "}
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("comes_from_fsl") ===
                  selectedData.status_of_muddamaal ||
                translatedText("released_in_fsl") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="fslList">FSL List</label>
                      <br />
                      <div className="input-group">
                        <select
                          id="fslList"
                          value={selectedData.fslList}
                          className="form-control"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              fslList: e.target.value,
                            })
                          }
                        >
                          <option value="FSL Port Blair">FSL Port Blair</option>
                          {userState === "Goa" && (
                            <option value="FSL Verna">FSL Verna</option>
                          )}
                          <option value="CFSL Pune">CFSL Pune</option>
                          <option value="CFSL Kolkata">CFSL Kolkata</option>
                          <option value="CFSL Chandigarh">
                            CFSL Chandigarh
                          </option>
                          <option value="CFSL Hyderabad">CFSL Hyderabad</option>
                          <option value="CFSL Bhopal">CFSL Bhopal</option>
                          <option value="CFSL Assam">CFSL Assam</option>
                          <option value="CFSL Ahmedabad">CFSL Ahmedabad</option>
                          <option value="CFSL Gandhinagar">
                            CFSL Gandhinagar
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    {selectedData.fslList === "Other" && (
                      <div className="form-group">
                        <label htmlFor="cfslName">
                          {translatedText("name_of_cfsl")}
                        </label>
                        <br />
                        <input
                          type="text"
                          id="cfslName"
                          // value={cfslName}
                          value={sectionCfslName}
                          className="form-control"
                          // onChange={handleCfslNameChange}
                          onChange={(e) => setSectionCfslName(e.target.value)}
                          placeholder={translatedText("enter_name_of_cfsl")}
                        />
                      </div>
                    )}

                    {selectedData.fslList === "All CFSL" && (
                      <div className="form-group">
                        <label htmlFor="cfslName">
                          {translatedText("name_of_cfsl")}
                        </label>
                        <br />
                        <input
                          type="text"
                          id="cfslName"
                          className="form-control"
                          value={sectionCfslName}
                          onChange={(e) => setSectionCfslName(e.target.value)}
                          placeholder={translatedText("enter_name_of_cfsl")}
                        />
                      </div>
                    )}
                  </>
                ) : null}

                {translatedText("handed_over_to_other_department") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="MemoNo">
                        {translatedText("handover_memo_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="MemoNo"
                          id="MemoNo"
                          className="form-control"
                          value={sectionMemoNo}
                          onChange={(e) => setSectionMemoNo(e.target.value)}
                          placeholder={translatedText("enter_handover_memo_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="DateOfHandingOver">
                        {translatedText("date_of_handing_over")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          name="DateOfHandingOver"
                          id="DateOfHandingOver"
                          className="form-control"
                          value={selectedDateOfHandingOver}
                          onChange={(e) =>
                            setSelectedDateOfHandingOver(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group-attachment attach-new">
                      <label htmlFor="Attachment">
                        Attachment for Handover memo
                      </label>
                      <div className="input-group-attachment">
                        <button
                          type="button"
                          className="challan-button"
                          onClick={handleUploadButtonClick}
                        >
                          <FiUpload /> Upload File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleHandedOverFileInputChange}
                        />
                        {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                          <span
                            className="inquiry-file-btn"
                            onClick={handleIconClick}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {`${selectedFiles.length}`}
                          </span>
                        )}
                        {isPopupOpens && (
                          <div className="attach-popups">
                            <div className="attach-popup-contant">
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={handleCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>
                              {selectedFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedFiles.map((file, index) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name.length > 15
                                              ? `${file.name.substring(
                                                  0,
                                                  15,
                                                )}...`
                                              : file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:(
                                            {(file.size / 1024).toFixed(2)} KB)
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteFile(index)
                                          }
                                        >
                                          <span>
                                            {" "}
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("police_station_account") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("name_of_the_account_holder")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={translatedText(
                            "enter_the_name_of_the_borrower_form_the_p_O_station",
                          )}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("date_received_from_the_p_o_station")}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          className="form-control"
                          name="bankTrans"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                    {userState === "Gujarat" && (
                      <div className="order-status form-group">
                        <label htmlFor="Order_Status">
                          {translatedText("malkhana_register_no")}
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            id="Order_Status"
                            className="form-control"
                            name="Order_Status"
                            placeholder={translatedText("enter_malkhana_nos")}
                            value={selectedData.order_no}
                            onChange={(e) =>
                              setSelectedData({
                                ...selectedData,
                                order_status: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : null}

                {translatedText("comes_from_fsl") ===
                  selectedData.status_of_muddamaal ||
                translatedText("comes_from_court") ===
                  selectedData.status_of_muddamaal ||
                translatedText("comes_from_bank") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("police_station_account") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("name_of_the_account_holder")
                          : translatedText("comes_from_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText(
                                "name_of_the_one_to_be_taken_from_FSL",
                              )
                            : translatedText("comes_from_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText(
                                  "name_of_the_person_be_summoned_from_the_court",
                                )
                              : translatedText("comes_from_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText(
                                    "name_of_the_borrower_from_the_bank",
                                  )
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={
                            translatedText("police_station_account") ===
                            selectedData.status_of_muddamaal
                              ? translatedText(
                                  "enter_the_name_of_the_borrower_form_the_p_O_station",
                                )
                              : translatedText("comes_from_fsl") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText(
                                    "enter_the_name_of_the_borrower_form_the_fsl",
                                  )
                                : translatedText("comes_from_court") ===
                                    selectedData.status_of_muddamaal
                                  ? translatedText(
                                      "enter_the_name_of_the_borrower_form_the_court",
                                    )
                                  : translatedText("comes_from_bank") ===
                                      selectedData.status_of_muddamaal
                                    ? translatedText(
                                        "enter_the_name_of_the_borrower_form_the_bank",
                                      )
                                    : "Name"
                          }
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("police_station_account") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("date_received_from_the_p_o_station")
                          : translatedText("comes_from_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText("date_received_from_the_fsl")
                            : translatedText("comes_from_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText("date_received_from_the_court")
                              : translatedText("comes_from_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText("date_received_from_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          className="form-control"
                          name="bankTrans"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>

                    <div className="order-status form-group">
                      <label htmlFor="Order_Status">
                        {translatedText("order_no")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Order_Status"
                          className="form-control"
                          name="Order_Status"
                          value={selectedData.order_no}
                          placeholder={translatedText("enter_order_no")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              order_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("returned") ===
                  selectedData.status_of_muddamaal ||
                translatedText("released_in_fsl") ===
                  selectedData.status_of_muddamaal ||
                translatedText("pending_in_court") ===
                  selectedData.status_of_muddamaal ||
                translatedText("deposited_in_bank") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("returned") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("name_of_the_returen")
                          : translatedText("released_in_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText("name_of_the_sender_in_fsl")
                            : translatedText("pending_in_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText(
                                  "name_of_the_depositing_in_court",
                                )
                              : translatedText("deposited_in_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText(
                                    "name_of_the_depositing_in_bank",
                                  )
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={
                            translatedText("returned") ===
                            selectedData.status_of_muddamaal
                              ? translatedText("enter_the_name_of_the_returnee")
                              : translatedText("released_in_fsl") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText("enter_the_name_of_the_sender")
                                : translatedText("pending_in_court") ===
                                    selectedData.status_of_muddamaal
                                  ? translatedText(
                                      "enter_the_name_of_the_submiter_person_court",
                                    )
                                  : translatedText("deposited_in_bank") ===
                                      selectedData.status_of_muddamaal
                                    ? translatedText(
                                        "enter_the_name_of_the_submiter_person_bank",
                                      )
                                    : "Name"
                          }
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("returned") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("return_date")
                          : translatedText("released_in_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText("date_deposite_in_the_fsl")
                            : translatedText("pending_in_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText("date_deposite_in_the_court")
                              : translatedText("deposited_in_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText("date_deposite_in_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>

                    <div className="send-status form-group">
                      <label htmlFor="Send_Status">
                        {translatedText("order_no")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Send_Status"
                          name="Send_Status"
                          className="form-control"
                          value={selectedData.javak_no}
                          placeholder={translatedText("enter_order_no")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              send_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </form>
              <div className="last-edit-buttons">
                <button
                  type="button"
                  className="btn close-button buttons"
                  onClick={() => setShowCasePropertyPopup(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  onClick={updateStatusDetails}
                  className="btn  save-button buttons"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showExportPopup && (
        <div
          className="export-popup-overlay"
          onClick={closeExportPopup}
          role="presentation"
        >
          <div
            className="export-popup"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="export-popup-title"
          >
            <div className="export-popup__header">
              <div>
                <h3 id="export-popup-title">Export Case Property</h3>
                <p>Choose format and export filters.</p>
              </div>
              <button
                type="button"
                className="export-popup__close"
                onClick={closeExportPopup}
                disabled={isExporting}
                aria-label="Close export popup"
              >
                <IoMdClose />
              </button>
            </div>

            <div className="export-popup__section">
              <label className="export-popup__label">Format</label>
              <div className="export-popup__radio-group">
                <label
                  className="export-popup__radio-option"
                  htmlFor="export-format-xlsx"
                >
                  <input
                    id="export-format-xlsx"
                    type="radio"
                    name="export-format"
                    value="xlsx"
                    checked={exportOptions.format === "xlsx"}
                    onChange={handleExportOptionChange("format")}
                    disabled={isExporting}
                  />
                  <span>Excel (.xlsx)</span>
                </label>
                <label
                  className="export-popup__radio-option"
                  htmlFor="export-format-csv"
                >
                  <input
                    id="export-format-csv"
                    type="radio"
                    name="export-format"
                    value="csv"
                    checked={exportOptions.format === "csv"}
                    onChange={handleExportOptionChange("format")}
                    disabled={isExporting}
                  />
                  <span>CSV (.csv)</span>
                </label>
              </div>
            </div>

            <div className="export-popup__grid">
              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="export-language"
                >
                  Language
                </label>
                <select
                  id="export-language"
                  className="export-popup__input"
                  value={exportOptions.lang}
                  onChange={handleExportOptionChange("lang")}
                  disabled={isExporting}
                >
                  <option value="en">English</option>
                  <option value="gu">Gujarati</option>
                  <option value="hi">Hindi</option>
                  <option value="mr">Marathi</option>
                </select>
              </div>

              <div className="export-popup__field">
                <label className="export-popup__label" htmlFor="export-status">
                  Status
                </label>
                <SearchableSelect
                  id="export-status"
                  className="export-popup__select"
                  value={exportOptions.status}
                  onChange={handleExportOptionChange("status")}
                  searchPlaceholder="Search status"
                  disabled={isExporting}
                >
                  <option value="">All Statuses</option>
                  {masterStatusOptions.map((option) => (
                    <option
                      key={option.id || option.code || option.value}
                      value={option.code || option.value}
                    >
                      {option.label || option.value}
                    </option>
                  ))}
                </SearchableSelect>
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="export-entry-type"
                >
                  Entry Type
                </label>
                <SearchableSelect
                  id="export-entry-type"
                  className="export-popup__select"
                  value={exportOptions.entryType}
                  onChange={handleExportOptionChange("entryType")}
                  searchPlaceholder="Search entry type"
                  disabled={isExporting}
                >
                  <option value="">All Entry Types</option>
                  {entryTypes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {getEntryTypeLabel(option, selectedLanguage)}
                    </option>
                  ))}
                </SearchableSelect>
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="export-start-date"
                >
                  Start Date
                </label>
                <input
                  id="export-start-date"
                  type="date"
                  className="export-popup__input"
                  value={exportOptions.startDate}
                  onChange={handleExportOptionChange("startDate")}
                  disabled={isExporting}
                />
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="export-end-date"
                >
                  End Date
                </label>
                <input
                  id="export-end-date"
                  type="date"
                  className="export-popup__input"
                  value={exportOptions.endDate}
                  onChange={handleExportOptionChange("endDate")}
                  disabled={isExporting}
                />
              </div>
            </div>

            <div className="export-popup__actions">
              <button
                type="button"
                className="export-popup__secondary-btn"
                onClick={() =>
                  setExportOptions({
                    ...INITIAL_EXPORT_OPTIONS,
                    lang: selectedLanguage,
                  })
                }
                disabled={isExporting}
              >
                Reset Filters
              </button>
              <button
                type="button"
                className="export-popup__primary-btn"
                onClick={exportCasePropertyData}
                disabled={isExporting}
              >
                {isExporting ? "Exporting..." : "Download"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showInsertDataPopup && (
        <div className="insert-data-popup" ref={insertRef}>
          <InsertData
            handleInsertPopupClose={handleInsertPopupClose}
            fetchUseData={fetchUseData}
          />
        </div>
      )}
      {showSubscriptionEndedPopup && (
        <PopupupScreen onClose={() => setShowSubscriptionEndedPopup(false)} />
      )}
      {/* {showInsertDataPopup && (
        <div className="insert-data-popup" ref={insertRef}>
          <InsertData  />
        </div>
      )} */}
      {/* {showDataView && selectedData && <DataView id={selectedData.id} />} */}
    </>
  );
}

export default DataList;
